import { createSvgIcon } from './svg-icon';

export const Icon360ViewIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M2 6.7273C2 5.2209 6.4773 4 12 4s10 1.221 10 2.7273m-5.4545 8.4818a33.3 33.3 0 0 0-4.5455-.3 33.3 33.3 0 0 0-4.5454.3"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M2 6.7273C2 5.2209 6.4773 4 12 4s10 1.221 10 2.7273M2 17.6364c0 1.0591 2.219 1.9754 5.4545 2.4272V9.1546C4.2191 8.7 2 7.7909 2 6.7273zm20 0c0 1.0591-2.2191 1.9754-5.4546 2.4272V9.1546C19.7809 8.7 22 7.7909 22 6.7273z"
      key="1"
    />,
  ],
  'Icon360View',
  24
);

export const DesktopIcon = createSvgIcon(
  [
    <g key="0">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M12 23v-4m-6 4h12"
      />
      <path
        fill="currentColor"
        d="M12 6c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M21 19H3c-1.105 0-2-.895-2-2V3c0-1.105.895-2 2-2h18c1.105 0 2 .895 2 2v14c0 1.105-.895 2-2 2M1 15h22"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Desktop',
  24
);

export const LaptopIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M3 13V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v8"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M12 8c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1"
      key="1"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M23 17a4 4 0 0 1-1.1716 2.8284A4 4 0 0 1 19 21H5a4 4 0 0 1-4-4z"
      key="2"
    />,
  ],
  'Laptop',
  24
);

export const AddCircleIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12 2c5.5228 0 10 4.4772 10 10s-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="2"
      d="M8 12h8m-4 4V8"
      key="1"
    />,
  ],
  'AddCircle',
  24
);

export const AddIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    d="M11.6569 6.3431V17.657M17.3137 12H6"
  />,
  'Add',
  24
);

export const AdministrationIcon = createSvgIcon(
  [
    <g stroke="currentColor" strokeWidth="2" key="0">
      <circle
        cx="12"
        cy="12"
        r="11"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        strokeLinecap="square"
        strokeMiterlimit="10"
        d="M12 15.75c2.0711 0 3.75-1.6789 3.75-3.75S14.0711 8.25 12 8.25 8.25 9.9289 8.25 12s1.6789 3.75 3.75 3.75Z"
      />
      <path
        strokeMiterlimit="10"
        d="M11.449 8.29 11.813 7h.375l.363 1.29m1.683.697 1.169-.655.265.265-.655 1.169m.697 1.683 1.29.363v.375l-1.29.364m-.697 1.6829.655 1.169-.265.265-1.169-.655m-1.683.6971L12.188 17h-.375l-.364-1.29m-1.683-.6971-1.169.655-.265-.265.655-1.169M8.29 12.551 7 12.188v-.375l1.29-.364m.697-1.683-.655-1.169.265-.265 1.169.655"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Administration',
  24
);

export const AlertIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12 2c.2414 0 .4759.063.6777.1797.2015.1165.3605.2805.4649.4697l9.7207 17.6416c.0965.1769.142.3718.1357.5664a1.115 1.115 0 0 1-.1738.5615c-.1094.1727-.2666.3202-.46.4239a1.345 1.345 0 0 1-.6416.1572H2.2744a1.344 1.344 0 0 1-.6406-.1582c-.193-.1037-.3499-.2513-.459-.4238a1.115 1.115 0 0 1-.1738-.5606 1.11 1.11 0 0 1 .1357-.5664l9.7207-17.6416c.1044-.1892.2634-.3532.4649-.4697A1.356 1.356 0 0 1 12 2m0 7v4"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M12 18.5c.8284 0 1.5-.6716 1.5-1.5s-.6716-1.5-1.5-1.5-1.5.6716-1.5 1.5.6716 1.5 1.5 1.5"
      key="1"
    />,
  ],
  'Alert',
  24
);

export const AllocateTicketsIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeWidth="2"
      d="M19.25 18h1.25c.828 0 1.5-.672 1.5-1.5v-3.4955c-1.65 0-3-1.35-3-3 0-1.6515 1.35-3 3-3V3.5c0-.828-.672-1.5-1.5-1.5h-17C2.672 2 2 2.672 2 3.5v3.5045c1.65 0 3 1.35 3 3s-1.35 3-3 3V16.5c0 .828.672 1.5 1.5 1.5h1.25"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="m12 13 1.391 2.798 3.109.449-2.25 2.178.531 3.075L12 20.048 9.219 21.5l.531-3.075-2.25-2.178 3.109-.449z"
      key="1"
    />,
  ],
  'AllocateTickets',
  24
);

export const AnimationsIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M12 17c2.761 0 5-2.239 5-5 0 2.761 2.239 5 5 5m-10 0c2.761 0 5 2.239 5 5 0-2.761 2.239-5 5-5M2 7c2.761 0 5-2.239 5-5 0 2.761 2.239 5 5 5M2 7c2.761 0 5 2.239 5 5 0-2.761 2.239-5 5-5"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M19 8c-.414 0-.75-.336-.75-.75 0-.828-.672-1.5-1.5-1.5-.414 0-.75-.336-.75-.75s.336-.75.75-.75c.828 0 1.5-.672 1.5-1.5 0-.414.336-.75.75-.75s.75.336.75.75c0 .828.672 1.5 1.5 1.5.414 0 .75.336.75.75s-.336.75-.75.75c-.828 0-1.5.672-1.5 1.5 0 .414-.336.75-.75.75M5 22c-.414 0-.75-.336-.75-.75 0-.828-.672-1.5-1.5-1.5-.414 0-.75-.336-.75-.75s.336-.75.75-.75c.828 0 1.5-.672 1.5-1.5 0-.414.336-.75.75-.75s.75.336.75.75c0 .828.672 1.5 1.5 1.5.414 0 .75.336.75.75s-.336.75-.75.75c-.828 0-1.5.672-1.5 1.5 0 .414-.336.75-.75.75"
      key="1"
    />,
  ],
  'Animations',
  24
);

export const AppIconIcon = createSvgIcon(
  [
    <g stroke="currentColor" strokeMiterlimit="10" strokeWidth="2" key="0">
      <path
        strokeLinecap="square"
        d="M14.8127 17.1496C12.9704 18.2133 9.0718 17 9.0718 17s.8935-3.9799 2.7409-5.0465C13.526 10.9643 15.2689 11.7336 16 13c.7312 1.2665.526 3.1604-1.1873 4.1496Z"
      />
      <path d="m16.4195 14.042 5.2076-1.8657c1.23-.4406 1.7608-1.8875 1.1075-3.019-.6503-1.1263-2.159-1.394-3.157-.56l-4.237 3.5405" />
      <path
        strokeLinecap="square"
        d="M19 19v1c0 1.1046-.8954 2-2 2H7c-1.1046 0-2-.8954-2-2V4c0-1.1046.8954-2 2-2h10c1.1046 0 2 .8954 2 2v.5"
      />
      <path
        strokeLinecap="square"
        d="M13.4397 5.1206h-2.8794a.0603.0603 0 0 1 0-.1206h2.8794a.0603.0603 0 0 1 0 .1206Z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'AppIcon',
  24
);

export const AppleIcon = createSvgIcon(
  [
    <g key="0">
      <path
        stroke="currentColor"
        strokeWidth="2"
        d="M18.033 12.6879c.0311 3.3294 2.9348 4.4373 2.967 4.4514-.0246.0781-.464 1.5788-1.5298 3.129-.9214 1.3402-1.8777 2.6755-3.3841 2.7031-1.4802.0271-1.9561-.8735-3.6484-.8735-1.6918 0-2.2206.8459-3.6218.9006-1.454.0549-2.5614-1.4491-3.4904-2.7845-1.8983-2.7313-3.349-7.7181-1.401-11.0843.9676-1.6717 2.697-2.7302 4.5741-2.7574 1.4279-.0271 2.7756.956 3.6485.956.8723 0 2.5101-1.1823 4.2318-1.0086.7208.0298 2.7441.2897 4.0432 2.1822-.1047.0646-2.4141 1.4026-2.3891 4.186Zm-2.7818-8.1753c.7719-.93 1.2916-2.2245 1.1498-3.5126-1.1128.0445-2.4583.738-3.2564 1.6674-.7153.823-1.3417 2.1404-1.1728 3.403 1.2403.0955 2.5074-.6272 3.2794-1.5578Z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Apple',
  24
);

export const AppsIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M4.5 7C5.8807 7 7 5.8807 7 4.5S5.8807 2 4.5 2 2 3.1193 2 4.5 3.1193 7 4.5 7M12 7c1.3807 0 2.5-1.1193 2.5-2.5S13.3807 2 12 2 9.5 3.1193 9.5 4.5 10.6193 7 12 7m7.5 0C20.8807 7 22 5.8807 22 4.5S20.8807 2 19.5 2 17 3.1193 17 4.5 18.1193 7 19.5 7m-15 7.5C5.8807 14.5 7 13.3807 7 12S5.8807 9.5 4.5 9.5 2 10.6193 2 12s1.1193 2.5 2.5 2.5m7.5 0c1.3807 0 2.5-1.1193 2.5-2.5S13.3807 9.5 12 9.5 9.5 10.6193 9.5 12s1.1193 2.5 2.5 2.5m7.5 0c1.3807 0 2.5-1.1193 2.5-2.5s-1.1193-2.5-2.5-2.5S17 10.6193 17 12s1.1193 2.5 2.5 2.5M4.5 22C5.8807 22 7 20.8807 7 19.5S5.8807 17 4.5 17 2 18.1193 2 19.5 3.1193 22 4.5 22m7.5 0c1.3807 0 2.5-1.1193 2.5-2.5S13.3807 17 12 17s-2.5 1.1193-2.5 2.5S10.6193 22 12 22m7.5 0c1.3807 0 2.5-1.1193 2.5-2.5S20.8807 17 19.5 17 17 18.1193 17 19.5s1.1193 2.5 2.5 2.5"
  />,
  'Apps',
  24
);

export const ArchiveContentIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M3 15h5v2h8v-2h5"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M3 5v14c0 1.1046.8954 2 2 2h14c1.1046 0 2-.8954 2-2V5c0-1.1046-.8954-2-2-2H5c-1.1046 0-2 .8954-2 2Zm4 2h4m-4 4h10"
      key="1"
    />,
  ],
  'ArchiveContent',
  24
);

export const ArchiveIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M3 5v14c0 1.1046.8954 2 2 2h14c1.1046 0 2-.8954 2-2V5c0-1.1046-.8954-2-2-2H5c-1.1046 0-2 .8954-2 2Z"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M3 15h5v2h8v-2h5"
      key="1"
    />,
  ],
  'Archive',
  24
);

export const ArrowDiagonalIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="m7.0502 17.1421 9.8995-9.8994-.3535.3535"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M8.4645 7.2426h8.4852v8.4853"
      key="1"
    />,
  ],
  'ArrowDiagonal',
  24
);

export const ArrowDownIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    d="M12 6v12m-6-6 6 6 6-6"
  />,
  'ArrowDown',
  24
);

export const ArrowLeftIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    d="M19 12H7m4-6-6 6 6 6"
  />,
  'ArrowLeft',
  24
);

export const ArrowRightIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    d="M5 12h12m-4-6 6 6-6 6"
  />,
  'ArrowRight',
  24
);

export const ArrowUpIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    d="M12 18V6m-6 6 6-6 6 6"
  />,
  'ArrowUp',
  24
);

export const ArrowsExpandDiagonalIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M9.5 14.5 3 20.9999l.1878-.1877M14.5 9.5 21 3l-.5.5"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M11 21H3v-8M13 3h8v8"
      key="1"
    />,
  ],
  'ArrowsExpandDiagonal',
  24
);

export const BarcodeIcon = createSvgIcon(
  [
    <g fill="currentColor" key="0">
      <path d="M20 0h-3v19h3zM6 0H4v19h2zm5 0H8v19h3zm4 0h-2v19h2zM2 0H0v24h2zm22 0h-2v24h2z" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Barcode',
  24
);

export const CalendarAddIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M21 10.5V6.1111C21 4.9451 20.1453 4 19.0909 4H3.9091C2.8547 4 2 4.9452 2 6.1111V19.889C2 21.0548 2.8547 22 3.909 22H9.5"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M17 23c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5-5 2.2386-5 5 2.2386 5 5 5Z"
      key="1"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M7 2v4m10-4v4"
      key="2"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M17 16v4m-2-2h4"
      key="3"
    />,
  ],
  'CalendarAdd',
  24
);

export const CalendarChangeIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M21 10.5V6.1111C21 4.9451 20.1453 4 19.0909 4H3.9091C2.8547 4 2 4.9452 2 6.1111V19.889C2 21.0548 2.8547 22 3.909 22H7.5M7 2v4m9-4v4"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M22 14v3.5h-3.5M12 23v-3.5h3.5"
      key="1"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M20.854 17.5h.388c-.454-2.004-2.246-3.5-4.388-3.5-1.3326 0-2.53.5794-3.354 1.5m-.354 4h-.388c.454 2.004 2.246 3.5 4.388 3.5 1.3326 0 2.53-.5794 3.354-1.5"
      key="2"
    />,
  ],
  'CalendarChange',
  24
);

export const CalendarCheckIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M19.0909 4H3.9091C2.8547 4 2 4.9452 2 6.1111V19.889C2 21.0548 2.8547 22 3.909 22h15.182C20.1453 22 21 21.0548 21 19.8889V6.1111C21 4.9451 20.1453 4 19.0909 4Z"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="m7 14 2.5 2.5L16 10M7 2v4m9-4v4"
      key="1"
    />,
  ],
  'CalendarCheck',
  24
);

export const CalendarClockIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M21 10.5V6.1111C21 4.9451 20.1453 4 19.0909 4H3.9091C2.8547 4 2 4.9452 2 6.1111V19.889C2 21.0548 2.8547 22 3.909 22H9.5"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M17 23c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5-5 2.2386-5 5 2.2386 5 5 5Z"
      key="1"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M17 16v2l1.25 1.25M7 2v4m9-4v4"
      key="2"
    />,
  ],
  'CalendarClock',
  24
);

export const CalendarRemoveIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M21 10.5V6.1111C21 4.9451 20.1453 4 19.0909 4H3.9091C2.8547 4 2 4.9452 2 6.1111V19.889C2 21.0548 2.8547 22 3.909 22H9.5"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M17 23c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5-5 2.2386-5 5 2.2386 5 5 5Z"
      key="1"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M7 2v4m9-4v4"
      key="2"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M15 18h4"
      key="3"
    />,
  ],
  'CalendarRemove',
  24
);

export const CalendarIcon = createSvgIcon(
  [
    <rect
      width="3"
      height="3"
      x="5"
      y="10"
      fill="currentColor"
      rx=".5"
      key="0"
    />,
    <rect
      width="3"
      height="3"
      x="5"
      y="15"
      fill="currentColor"
      rx=".5"
      key="1"
    />,
    <rect
      width="3"
      height="3"
      x="10"
      y="10"
      fill="currentColor"
      rx=".5"
      key="2"
    />,
    <rect
      width="3"
      height="3"
      x="10"
      y="15"
      fill="currentColor"
      rx=".5"
      key="3"
    />,
    <rect
      width="3"
      height="3"
      x="15"
      y="10"
      fill="currentColor"
      rx=".5"
      key="4"
    />,
    <rect
      width="3"
      height="3"
      x="15"
      y="15"
      fill="currentColor"
      rx=".5"
      key="5"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M19.0909 4H3.9091C2.8547 4 2 4.9452 2 6.1111V19.889C2 21.0548 2.8547 22 3.909 22h15.182C20.1453 22 21 21.0548 21 19.8889V6.1111C21 4.9451 20.1453 4 19.0909 4Z"
      key="6"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M7 2v4m9-4v4"
      key="7"
    />,
  ],
  'Calendar',
  24
);

export const CallIcon = createSvgIcon(
  [
    <g
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      key="0"
    >
      <path d="M14.308 15.191 12.167 17.3a17.4 17.4 0 0 1-3.092-2.376 17.6 17.6 0 0 1-2.375-3.09l2.11-2.141a.918.918 0 0 0 .189-1L6.8 3.56a.918.918 0 0 0-1.078-.525L1.688 4.1A.919.919 0 0 0 1 5.019a19.4 19.4 0 0 0 5.49 12.492A19.4 19.4 0 0 0 18.986 23a.917.917 0 0 0 .917-.688l1.066-4.036a.917.917 0 0 0-.524-1.078L15.316 15a.917.917 0 0 0-1.008.191ZM14 1a9.0003 9.0003 0 0 1 9 9m-9-5a4.9997 4.9997 0 0 1 5 5" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Call',
  24
);

export const CameraIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M12 16c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4-4 1.7909-4 4 1.7909 4 4 4Z"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M21.1818 20.1818H2.8182A1.818 1.818 0 0 1 1 18.3636V6.5454a1.818 1.818 0 0 1 1.8182-1.8181h4.6364L9.2727 2h5.4546l1.8182 2.7273h4.6363A1.8184 1.8184 0 0 1 23 6.5455v11.8181a1.818 1.818 0 0 1-1.8182 1.8182Z"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M4.7275 9.3637a.909.909 0 1 0 0-1.8182.909.909 0 0 0 0 1.8182"
      key="2"
    />,
  ],
  'Camera',
  24
);

export const Camera360Icon = createSvgIcon(
  [
    <g stroke="currentColor" strokeMiterlimit="10" strokeWidth="2" key="0">
      <path strokeLinecap="square" d="m11 16 3 3-3 3" />
      <path d="M5 11.914c-2.443.734-4 1.844-4 3.086 0 2.209 4.925 4 11 4 .661 0 1.306-.024 1.935-.065" />
      <path
        strokeLinecap="square"
        d="M18.8 18.141C21.353 17.408 23 16.275 23 15c0-1.242-1.557-2.352-4-3.086"
      />
      <path
        strokeLinecap="square"
        d="M18 13H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h3l1-2h4l1 2h3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1Z"
      />
      <path
        strokeLinecap="square"
        d="M12 10c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2Z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Camera360',
  24
);

export const CardAddIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M1 7h20m0 2V4c0-1.1046-.8954-2-2-2H3c-1.1046 0-2 .8954-2 2v12c0 1.1046.8954 2 2 2h5m-3-4h2"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M17 15v4m-2-2h4"
      key="1"
    />,
    <circle
      cx="17"
      cy="17"
      r="5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      key="2"
    />,
  ],
  'CardAdd',
  24
);

export const CardEditIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="square"
    strokeMiterlimit="10"
    strokeWidth="2"
    d="M2 9h20m0 0V6c0-1.1046-.8954-2-2-2H4c-1.1046 0-2 .8954-2 2v12c0 1.1046.8954 2 2 2h5m-3-4h2m8 7 6-6c.8284-.8284.8284-2.1716 0-3s-2.1716-.8284-3 0l-6 6v3z"
  />,
  'CardEdit',
  24
);

export const CardRemoveIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M1 7h20m0 2V4c0-1.1046-.8954-2-2-2H3c-1.1046 0-2 .8954-2 2v12c0 1.1046.8954 2 2 2h5m-3-4h2"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M15 17h4"
      key="1"
    />,
    <circle
      cx="17"
      cy="17"
      r="5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      key="2"
    />,
  ],
  'CardRemove',
  24
);

export const CardIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="square"
    strokeMiterlimit="10"
    strokeWidth="2"
    d="M22 14v4c0 1.1046-.8954 2-2 2H4c-1.1046 0-2-.8954-2-2V6c0-1.1046.8954-2 2-2h8M2 9h10m7.0004 1c0-1.8348-1.0779-3-3.0003-3M16 3c4.0798 0 6.9997 2.9936 6.9997 7M6 16h2"
  />,
  'Card',
  24
);

export const CaretDownIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="square"
    strokeMiterlimit="10"
    strokeWidth="2"
    d="M7.5182 9.7774C7.2967 9.445 7.535 9 7.9342 9h8.1315c.3994 0 .6376.445.4161.7774L12 16.5z"
  />,
  'CaretDown',
  24
);

export const CaretExpandIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="square"
    strokeMiterlimit="10"
    strokeWidth="2"
    d="M8.5775 8.206c-.2403.3304-.0043.794.4044.794h6.0362c.4087 0 .6447-.4636.4044-.794L12 3.5zm6.845 7.5881c.2403-.3305.0043-.7941-.4044-.7941H8.9819c-.4087 0-.6447.4636-.4044.7941L12 20.5z"
  />,
  'CaretExpand',
  24
);

export const CaretLeftIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="square"
    strokeMiterlimit="10"
    strokeWidth="2"
    d="M14.2227 7.5182c.3322-.2215.7773.0167.7773.416v8.1315c0 .3994-.4451.6376-.7774.4161L7.5 12z"
  />,
  'CaretLeft',
  24
);

export const CaretRightIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="square"
    strokeMiterlimit="10"
    strokeWidth="2"
    d="M9.7774 7.5182C9.445 7.2967 9 7.535 9 7.9342v8.1315c0 .3994.445.6376.7774.4161L16.5 12z"
  />,
  'CaretRight',
  24
);

export const CaretUpIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="square"
    strokeMiterlimit="10"
    strokeWidth="2"
    d="M7.5182 14.2227c-.2215.3322.0167.7773.416.7773h8.1315c.3994 0 .6376-.4451.4161-.7774L12 7.5z"
  />,
  'CaretUp',
  24
);

export const CartAddIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M6 22c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1Z"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M4.821 6H22l-.7 3.5M1 2h3l1.7547 12.2828C5.8955 15.2681 6.7393 16 7.7346 16H9"
      key="1"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M18 16v4m-2-2h4"
      key="2"
    />,
    <circle
      cx="18"
      cy="18"
      r="5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      key="3"
    />,
  ],
  'CartAdd',
  24
);

export const CartRemoveIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M6 22c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1Z"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M4.821 6H22l-.7 3.5M1 2h3l1.7547 12.2828C5.8955 15.2681 6.7393 16 7.7346 16H9"
      key="1"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M16 18h4"
      key="2"
    />,
    <circle
      cx="18"
      cy="18"
      r="5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      key="3"
    />,
  ],
  'CartRemove',
  24
);

export const CartIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M6 22c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1m14 0c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1"
      key="0"
    />,
    <path
      fill="currentColor"
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M6 22c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1Zm14 0c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1Z"
      key="1"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M4.821 6H22l-1.678 8.392c-.187.935-1.008 1.608-1.961 1.608H7.735c-.995 0-1.839-.732-1.98-1.717L4 2H1"
      key="2"
    />,
  ],
  'Cart',
  24
);

export const CenterIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M12 14c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M14.6569 4.6569 12 2 9.3431 4.6569M4.6569 9.3432 2 12l2.6569 2.6569m14.6862 0L22 12l-2.6569-2.6569m-9.9999 10L12 22l2.6569-2.6569"
      key="1"
    />,
  ],
  'Center',
  24
);

export const ChartAreaIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeMiterlimit="10"
    strokeWidth="2"
    d="M1 21h22M1.0005 10.9999l5-8 6 4.5 5-2L23.25 11.25M1.0005 16.9999l5-5 6 4.5 5-2L23.25 14.25"
  />,
  'ChartArea',
  24
);

export const ChartBarHorizontalIcon = createSvgIcon(
  [
    <g stroke="currentColor" strokeMiterlimit="10" strokeWidth="2" key="0">
      <path d="M0 23h19.3366" />
      <path
        strokeLinecap="square"
        d="M.7485 7.7498h9.75M.7486 12.7507h6M.7485 17.7502h9.75m-9.7499-15h13.4999"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'ChartBarHorizontal',
  24
);

export const ChartBarIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeWidth="2"
    d="M10 4c0-.5523.4477-1 1-1h2c.5523 0 1 .4477 1 1v16c0 .5523-.4477 1-1 1h-2c-.5523 0-1-.4477-1-1zm8 6c0-.5523.4477-1 1-1h2c.5523 0 1 .4477 1 1v10c0 .5523-.4477 1-1 1h-2c-.5523 0-1-.4477-1-1zM2 16c0-.5523.4477-1 1-1h2c.5523 0 1 .4477 1 1v4c0 .5523-.4477 1-1 1H3c-.5523 0-1-.4477-1-1z"
  />,
  'ChartBar',
  24
);

export const ChartBar2Icon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M1 21h22"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M6.999 16.5V6.75M12 16.4999v-6M16.9995 16.5V6.75m4.9995 9.7499v-6M1.9995 16.5V3"
      key="1"
    />,
  ],
  'ChartBar2',
  24
);

export const ChartDonutIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M16 12h6M12 2v6m-2.96 6.687-4.404 4.131"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M12 22c5.5228 0 10-4.4772 10-10S17.5228 2 12 2 2 6.4772 2 12s4.4772 10 10 10Z"
      key="1"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M12 16c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4-4 1.7909-4 4 1.7909 4 4 4Z"
      key="2"
    />,
  ],
  'ChartDonut',
  24
);

export const ChartLinePointIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M1 21h22M1.0005 13.9999l7-7 5 4 8-8"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M22 9.0711v-7.071h-7.071"
      key="1"
    />,
  ],
  'ChartLinePoint',
  24
);

export const ChartLineIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeMiterlimit="10"
    strokeWidth="2"
    d="M1 21h22M1.0005 13.9999l8-8 6 6 8-8"
  />,
  'ChartLine',
  24
);

export const ChartPaceIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M1 21h22"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M2 17C21 17 21 5 21 5"
      key="1"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M21 5c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2"
      key="2"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M4 3H2m8 0H8m8 0h-2"
      key="3"
    />,
  ],
  'ChartPace',
  24
);

export const ChartPieIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="m5 19 3.5-3.5L12 12m0 0V2m0 10h10"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M12 22c5.5228 0 10-4.4772 10-10S17.5228 2 12 2 2 6.4772 2 12s4.4772 10 10 10Z"
      key="1"
    />,
  ],
  'ChartPie',
  24
);

export const ChatIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="square"
    strokeMiterlimit="10"
    strokeWidth="2"
    d="M4 2h16c1.105 0 2 .895 2 2v11c0 1.105-.895 2-2 2h-7l-7 5v-5H4c-1.105 0-2-.895-2-2V4c0-1.105.895-2 2-2Z"
  />,
  'Chat',
  24
);

export const CheckIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    d="M5 11.1538 9.9 16 19 7"
  />,
  'Check',
  24
);

export const CheckboxBlankIcon = createSvgIcon(
  <rect
    width="16"
    height="16"
    x="4"
    y="4"
    stroke="currentColor"
    strokeWidth="2"
    rx="2"
  />,
  'CheckboxBlank',
  24
);

export const CheckboxIndeterminateIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeWidth="2"
      d="M3 6c0-1.6569 1.3431-3 3-3h12c1.6569 0 3 1.3431 3 3v12c0 1.6569-1.3431 3-3 3H6c-1.6569 0-3-1.3431-3-3z"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M8 12h8"
      key="1"
    />,
  ],
  'CheckboxIndeterminate',
  24
);

export const CheckboxIcon = createSvgIcon(
  [
    <rect
      width="18"
      height="18"
      x="3"
      y="3"
      stroke="currentColor"
      strokeWidth="2"
      rx="3"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.7071 8.2929c.3905.3905.3905 1.0237 0 1.4142l-6.6667 6.6667a1 1 0 0 1-1.4142 0L6.293 13.0404c-.3905-.3905-.3905-1.0236 0-1.4142s1.0237-.3905 1.4142 0l2.6262 2.6263 5.9596-5.9596c.3905-.3905 1.0237-.3905 1.4142 0"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'Checkbox',
  24
);

export const CheckmarkIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="m7 12.3333 3.3333 3.3334L17 9"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12 2c5.5228 0 10 4.4772 10 10s-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2"
      key="1"
    />,
  ],
  'Checkmark',
  24
);

export const ChevronDoubleLeftIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    d="m19 6-6 6 6 6M11 6l-6 6 6 6"
  />,
  'ChevronDoubleLeft',
  24
);

export const ChevronDoubleRightIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    d="m5 6 6 6-6 6m8-12 6 6-6 6"
  />,
  'ChevronDoubleRight',
  24
);

export const ChevronDownIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    d="m18 9-6 6-6-6"
  />,
  'ChevronDown',
  24
);

export const ChevronLeftIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    d="m14 6-6 6 6 6"
  />,
  'ChevronLeft',
  24
);

export const ChevronRightIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    d="m10 6 6 6-6 6"
  />,
  'ChevronRight',
  24
);

export const ChevronUpIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    d="m18 15-6-6-6 6"
  />,
  'ChevronUp',
  24
);

export const CityIcon = createSvgIcon(
  [
    <g
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      key="0"
    >
      <path d="M5 23H1V13h4m4 3h2m-2 3h2m-2-6h2m2-7V2l10 3v18H5V9h10v14m4-4V9" />
    </g>,
    <defs key="1"></defs>,
  ],
  'City',
  24
);

export const ClockIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M12 22c5.5228 0 10-4.4772 10-10S17.5228 2 12 2 2 6.4772 2 12s4.4772 10 10 10Z"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M12 6v6l4 3"
      key="1"
    />,
  ],
  'Clock',
  24
);

export const CloseIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="square"
    strokeMiterlimit="10"
    strokeWidth="2"
    d="M12 22c5.5228 0 10-4.4772 10-10S17.5228 2 12 2 2 6.4772 2 12s4.4772 10 10 10Zm3.5-13.5-7 7m7 0-7-7"
  />,
  'Close',
  24
);

export const CloudDownloadIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M12 11v9-.5m-4.2427-3.7428L12 19.9999l4.2426-4.2427"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M19 19c2.2 0 4-1.8 4-4s-1.8-4-4-4c-.3-3.9-3.5-7-7.5-7S4.2 7.2 4 11.1c-1.7.4-3 2-3 3.9 0 2.2 1.8 4 4 4"
      key="1"
    />,
  ],
  'CloudDownload',
  24
);

export const CloudUploadIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M11.9997 21V11l.0002 1"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="m16.2426 15.2428-4.2427-4.2427-4.2426 4.2427"
      key="1"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M19 19c2.2 0 4-1.8 4-4s-1.8-4-4-4c-.3-3.9-3.5-7-7.5-7S4.2 7.2 4 11.1c-1.7.4-3 2-3 3.9 0 2.2 1.8 4 4 4"
      key="2"
    />,
  ],
  'CloudUpload',
  24
);

export const ClusterIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="square"
    strokeMiterlimit="10"
    strokeWidth="2"
    d="M10.101 20.0001c1.2626 1.2371 2.9917 2 4.899 2 3.866 0 7-3.134 7-7 0-1.9073-.7628-3.6365-2-4.899M9 16c-3.866 0-7-3.134-7-7s3.134-7 7-7 7 3.134 7 7-3.134 7-7 7Z"
  />,
  'Cluster',
  24
);

export const CollapseHorizontalIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M21 12H8.5m5 5-5-5 5-5"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M3 21V3"
      key="1"
    />,
  ],
  'CollapseHorizontal',
  24
);

export const CopyIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="square"
    strokeMiterlimit="10"
    strokeWidth="2"
    d="M9 21h-.5c-.828 0-1.5-.672-1.5-1.5V17m8 4h-2m8-2v.5c0 .828-.672 1.5-1.5 1.5H19m2-8v2m-4-8h2.5c.828 0 1.5.672 1.5 1.5V9m-5.5-6h-11C3.6716 3 3 3.6716 3 4.5v11c0 .8284.6716 1.5 1.5 1.5h11c.8284 0 1.5-.6716 1.5-1.5v-11c0-.8284-.6716-1.5-1.5-1.5Z"
  />,
  'Copy',
  24
);

export const CornerLeftUpIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M9 5v8c0 3.314 2.686 6 6 6h5"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M14 9 9 4 4 9"
      key="1"
    />,
  ],
  'CornerLeftUp',
  24
);

export const CornerRightUpIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M15 5v8c0 3.314-2.686 6-6 6H4"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="m10 9 5-5 5 5"
      key="1"
    />,
  ],
  'CornerRightUp',
  24
);

export const CrossIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    d="M18 6 6 18m12 0L6 6"
  />,
  'Cross',
  24
);

export const CurrencyIcon = createSvgIcon(
  [
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      key="0"
    >
      <path d="M1 4v4c0 1.657 2.686 3 6 3s6-1.343 6-3V4" />
      <path d="M1 8v4c0 1.657 2.686 3 6 3 1.537 0 2.938-.29 4-.765" />
      <path d="M1 12v4c0 1.657 2.686 3 6 3 1.537 0 2.939-.289 4-.764M7 7c3.3137 0 6-1.3431 6-3s-2.6863-3-6-3-6 1.3432-6 3 2.6863 3 6 3m4 5v4c0 1.657 2.686 3 6 3s6-1.343 6-3v-4" />
      <path d="M11 16v4c0 1.657 2.686 3 6 3s6-1.343 6-3v-4m-6-1c3.3137 0 6-1.3431 6-3s-2.6863-3-6-3-6 1.3431-6 3 2.6863 3 6 3" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Currency',
  24
);

export const CustomersIcon = createSvgIcon(
  [
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      key="0"
    >
      <path d="M4 7c-1.105 0-2-.895-2-2s.895-2 2-2 2 .895 2 2-.895 2-2 2m2 14H3v-4H1v-5c0-1.105.895-2 2-2h1m16-3c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2m-2 14h3v-4h2v-5c0-1.105-.895-2-2-2h-1m-8-3c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3m3 16H9v-6H7v-5c0-1.105.895-2 2-2h6c1.105 0 2 .895 2 2v6h-2z" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Customers',
  24
);

export const DarkModeIcon = createSvgIcon(
  [
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      key="0"
    >
      <path d="M18 16C12.5 16 8 11.5 8 6c0-.9.1-1.8.4-2.6C4.1 4.5 1 8.4 1 13c0 5.5 4.5 10 10 10 4.6 0 8.5-3.1 9.6-7.4-.8.3-1.7.4-2.6.4M15 1v4m-2-2h4m4 4v4m-2-2h4" />
    </g>,
    <defs key="1"></defs>,
  ],
  'DarkMode',
  24
);

export const DashboardsIcon = createSvgIcon(
  [
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      key="0"
    >
      <path d="M6.3 10c-.2.6-.3 1.3-.3 2m12 0c0-3.3-2.7-6-6-6-.7 0-1.4.1-2 .3m.6 4.3L7 7m5 7c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2" />
      <path d="M12 23c6.0751 0 11-4.9249 11-11S18.0751 1 12 1 1 5.9249 1 12s4.9249 11 11 11" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Dashboards',
  24
);

export const DeclineTicketsIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeWidth="2"
      d="M19.25 18h1.25c.828 0 1.5-.672 1.5-1.5v-3.4955c-1.65 0-3-1.35-3-3 0-1.6515 1.35-3 3-3V3.5c0-.828-.672-1.5-1.5-1.5h-17C2.672 2 2 2.672 2 3.5v3.5045c1.65 0 3 1.35 3 3s-1.35 3-3 3V16.5c0 .828.672 1.5 1.5 1.5h1.25"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="m15 15-6 6m0-6 6 6"
      key="1"
    />,
  ],
  'DeclineTickets',
  24
);

export const DiplomaIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M8 19v1.5C8 22.75 5.5 23 5.5 23h15c1.381 0 2.5-1.119 2.5-2.5V19z"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M13 1H3v19.5C3 21.881 4.119 23 5.5 23H7"
      key="1"
    />,
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M22 7.646V15l-3-2-3 2V7.646"
      key="2"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M19 9c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4-4 1.7909-4 4 1.7909 4 4 4Z"
      key="3"
    />,
  ],
  'Diploma',
  24
);

export const DiscountTicketsIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeWidth="2"
      d="M19.25 18h1.25c.828 0 1.5-.672 1.5-1.5v-3.4955c-1.65 0-3-1.35-3-3 0-1.6515 1.35-3 3-3V3.5c0-.828-.672-1.5-1.5-1.5h-17C2.672 2 2 2.672 2 3.5v3.5045c1.65 0 3 1.35 3 3s-1.35 3-3 3V16.5c0 .828.672 1.5 1.5 1.5h1.25"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="m15 14-6 6"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M9.5 15c.8284 0 1.5-.6716 1.5-1.5S10.3284 12 9.5 12 8 12.6716 8 13.5 8.6716 15 9.5 15m5 7c.8284 0 1.5-.6716 1.5-1.5s-.6716-1.5-1.5-1.5-1.5.6716-1.5 1.5.6716 1.5 1.5 1.5"
      key="2"
    />,
  ],
  'DiscountTickets',
  24
);

export const DonateIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    d="M17 15h1.838a3 3 0 0 1 2.846 2.052L22 18l-11.468 3.529a4 4 0 0 1-2.965-.246L1 18v-7h1c1.105 0 3.906.438 5 2h3a4 4 0 0 1 2.8284 1.1716A4 4 0 0 1 14 17H8M19.2 1.812a2.7 2.7 0 0 0-2.203-.7972A2.7 2.7 0 0 0 15 2.24a2.7 2.7 0 0 0-3.1895-1.078 2.7 2.7 0 0 0-1.0105.65 2.8 2.8 0 0 0 0 3.919L15 10l4.2-4.269a2.8 2.8 0 0 0 0-3.919"
  />,
  'Donate',
  24
);

export const DownloadDataIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M12 6v11"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="m8 13 4 4 4-4M2 8V4a2 2 0 0 1 2-2h4m8 0h4a2 2 0 0 1 2 2v4m0 8v4a2 2 0 0 1-2 2h-4m-8 0H4a2 2 0 0 1-2-2v-4"
      key="1"
    />,
  ],
  'DownloadData',
  24
);

export const DownloadIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="square"
    strokeMiterlimit="10"
    strokeWidth="2"
    d="M3 16v3c0 1.105.895 2 2 2h14c1.105 0 2-.895 2-2v-3M12 3v12-1m-5-4 5 5 5-5"
  />,
  'Download',
  24
);

export const DropdownCircleIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M12 22c5.5228 0 10-4.4772 10-10S17.5228 2 12 2 2 6.4772 2 12s4.4772 10 10 10Z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M8.1742 9C7.32 9 6.859 10.0021 7.415 10.6508l3.8257 4.4634c.3991.4656 1.1195.4656 1.5186 0l3.8257-4.4634C17.141 10.0021 16.6801 9 15.8258 9z"
      key="1"
    />,
  ],
  'DropdownCircle',
  24
);

export const DropupCircleIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M12 22c5.5228 0 10-4.4772 10-10S17.5228 2 12 2 2 6.4772 2 12s4.4772 10 10 10Z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M8.1742 15c-.8543 0-1.3152-1.0021-.7592-1.6508l3.8257-4.4634c.3991-.4656 1.1195-.4656 1.5186 0l3.8257 4.4634c.556.6487.0951 1.6508-.7592 1.6508z"
      key="1"
    />,
  ],
  'DropupCircle',
  24
);

export const DuplicateIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M7 17H4.5c-.828 0-1.5-.672-1.5-1.5v-11C3 3.672 3.672 3 4.5 3h11c.828 0 1.5.672 1.5 1.5V7"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M14 11v6m3-3h-6m8.5-7h-11C7.6716 7 7 7.6716 7 8.5v11c0 .8284.6716 1.5 1.5 1.5h11c.8284 0 1.5-.6716 1.5-1.5v-11c0-.8284-.6716-1.5-1.5-1.5Z"
      key="1"
    />,
  ],
  'Duplicate',
  24
);

export const EasterIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M3.5613 10S6.375 11 12 11s8.4339-1 8.4339-1M3 15s3.4375 1 9 1 9-1 9-1"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M3 15C3 7 7 1 12 1c4.9583 0 9 6 9 14 0 5-4.5817 8-9 8s-9-3-9-8Z"
      key="1"
    />,
  ],
  'Easter',
  24
);

export const EditTicketsIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="m10 21.6213 6-6c.8284-.8284.8284-2.1716 0-3s-2.1716-.8284-3 0l-6 6v3z"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeWidth="2"
      d="M19.25 18h1.25c.828 0 1.5-.672 1.5-1.5v-3.4955c-1.65 0-3-1.35-3-3 0-1.6515 1.35-3 3-3V3.5c0-.828-.672-1.5-1.5-1.5h-17C2.672 2 2 2.672 2 3.5v3.5045c1.65 0 3 1.35 3 3s-1.35 3-3 3V16.5c0 .828.672 1.5 1.5 1.5h1.25"
      key="1"
    />,
  ],
  'EditTickets',
  24
);

export const EditIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="m14 5 5 5"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="m9 20-7 2 2-7L16.414 2.586c.781-.781 2.047-.781 2.828 0l2.172 2.172c.781.781.781 2.047 0 2.828z"
      key="1"
    />,
  ],
  'Edit',
  24
);

export const EmailOpenIcon = createSvgIcon(
  [
    <g stroke="currentColor" strokeMiterlimit="10" strokeWidth="2" key="0">
      <path d="m1 9 11.001 8L23 9" />
      <path
        strokeLinecap="square"
        d="M11.999 1 1 9v12c0 1.105.895 2 2 2h18c1.105 0 2-.895 2-2V9z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'EmailOpen',
  24
);

export const EmailIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="m2 8 10 5 10-5"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M20 4H4c-1.1046 0-2 .8954-2 2v12c0 1.1046.8954 2 2 2h16c1.1046 0 2-.8954 2-2V6c0-1.1046-.8954-2-2-2Z"
      key="1"
    />,
  ],
  'Email',
  24
);

export const EnterKeyIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M20 6v6c0 1.1046-.8954 2-2 2H4h.5"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="m9 9-5 5 5 5"
      key="1"
    />,
  ],
  'EnterKey',
  24
);

export const EntranceIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    d="M11 10h11m-4-4 4 4-4 4m-5-1v4H8M1 2l7 5.016V22l-7-5zm0 0h12v5"
  />,
  'Entrance',
  24
);

export const EventGroupIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M22 10V8c0-1.1046-.8954-2-2-2h-7l-3-3H4c-1.1046 0-2 .8954-2 2v13c0 1.1046.8954 2 2 2h8"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M18 13h-3v3h3zm0 5h-3v3h3zm5-5h-3v3h3zm0 5h-3v3h3z"
      key="1"
    />,
  ],
  'EventGroup',
  24
);

export const EventImageIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M22 18V6c0-1.1046-.8954-2-2-2H4c-1.1046 0-2 .8954-2 2v12c0 1.1046.8954 2 2 2h16c1.1046 0 2-.8954 2-2Z"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="m2 18 4.5-5 4 3.5 6-7.5 5.5 7"
      key="1"
    />,
    <path
      fill="currentColor"
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M9 10c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1Z"
      key="2"
    />,
  ],
  'EventImage',
  24
);

export const ExchangeTicketsIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M17 14v3.5h-3.5M7 23v-3.5h3.5"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M15.854 17.5h.388c-.454-2.004-2.246-3.5-4.388-3.5-1.3326 0-2.53.5794-3.354 1.5m-.354 4h-.388c.454 2.004 2.246 3.5 4.388 3.5 1.3326 0 2.53-.5794 3.354-1.5"
      key="1"
    />,
    <path
      stroke="currentColor"
      strokeWidth="2"
      d="M20 18h.5c.828 0 1.5-.672 1.5-1.5v-3.4955c-1.65 0-3-1.35-3-3 0-1.6515 1.35-3 3-3V3.5c0-.828-.672-1.5-1.5-1.5h-17C2.672 2 2 2.672 2 3.5v3.5045c1.65 0 3 1.35 3 3s-1.35 3-3 3V16.5c0 .828.672 1.5 1.5 1.5H4"
      key="2"
    />,
  ],
  'ExchangeTickets',
  24
);

export const ExclamationIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12 22c5.5228 0 10-4.4772 10-10S17.5228 2 12 2 2 6.4772 2 12s4.4772 10 10 10"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12 7v6"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M12 18c-.6904 0-1.25-.5596-1.25-1.25s.5596-1.25 1.25-1.25 1.25.5596 1.25 1.25S12.6904 18 12 18"
      key="2"
    />,
  ],
  'Exclamation',
  24
);

export const ExpandHorizontalIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M3 12h12.5m-5-5 5 5-5 5"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M21 3v18"
      key="1"
    />,
  ],
  'ExpandHorizontal',
  24
);

export const ExpiredIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M20 10c0-4.9706-4.0294-9-9-9s-9 4.0294-9 9c0 3.9315 2.521 7.2743 6.0345 8.5"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M11.5 6v5H8"
      key="1"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M13 22h-.2339c-.7772 0-1.2573-.848-.8574-1.5145l4.2338-7.0564c.3884-.6473 1.3266-.6473 1.715.0001l4.2338 7.0563c.3999.6665-.0802 1.5145-.8575 1.5145h-.2345M17 18v1.5"
      key="2"
    />,
    <path
      fill="currentColor"
      d="M17 24c.6904 0 1.25-.5596 1.25-1.25S17.6904 21.5 17 21.5s-1.25.5596-1.25 1.25S16.3096 24 17 24"
      key="3"
    />,
  ],
  'Expired',
  24
);

export const ExportIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M20 10V4c0-1.1046-.8954-2-2-2h-6.9216a2 2 0 0 0-1.4142.5858L4.5858 7.6642A2 2 0 0 0 4 9.0784V20c0 1.1046.8954 2 2 2h5"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M4 9h7V2"
      key="1"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="m22 18.5-4 4-4-4"
      key="2"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="m17.999 21.5.001 1V14"
      key="3"
    />,
  ],
  'Export',
  24
);

export const ExternalLinkIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M2.7929 20.7929c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0L3.5 21.5zM13.9999 11l.7072.707-1.4143-1.4141zm-1.2071-.207-.707.7071 1.4143 1.4141.7071-.7072L13.5 11.5zM3.5 21.5l.707.7071 10.5-10.5L13.9999 11l-.7071-.7071-10.5 10.5zM13.9999 11l-.7072-.707-.4999.5.7072.707.7072.707.4999-.5z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M8 10c-.5523 0-1 .4477-1 1s.4477 1 1 1zm6 1h1v-1h-1zm-1 6v1h2v-1zm-5-6v1h6v-2H8zm6 0h-1v6h2v-6z"
      key="1"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M11 22h9c1.1046 0 2-.8954 2-2V4c0-1.1046-.8954-2-2-2H4c-1.1046 0-2 .8954-2 2v11"
      key="2"
    />,
  ],
  'ExternalLink',
  24
);

export const FamilyIcon = createSvgIcon(
  [
    <g
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      key="0"
    >
      <path d="M6.5 6C7.8807 6 9 4.8807 9 3.5S7.8807 1 6.5 1 4 2.1193 4 3.5 5.1193 6 6.5 6Zm11 0C18.8807 6 20 4.8807 20 3.5S18.8807 1 17.5 1 15 2.1193 15 3.5 16.1193 6 17.5 6ZM12 17c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2Zm-3 6v-3h6v3M5 17l4 3m10-3-4 3M1 20v-5.5A5.5 5.5 0 0 1 6.5 9a5.476 5.476 0 0 1 3.163 1M23 20v-5.5A5.5003 5.5003 0 0 0 17.5 9a5.476 5.476 0 0 0-3.163 1" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Family',
  24
);

export const FeaturedImageIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M11 4H4c-1.1046 0-2 .8954-2 2v12c0 1.1046.8954 2 2 2h16c1.1046 0 2-.8954 2-2v-5"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M7 10c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1Z"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M20.5 3.5 19 0l-1.5 3.5L14 5l3.5 1.5L19 10l1.5-3.5L24 5z"
      key="2"
    />,
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="m6 20 7-8 7 8"
      key="3"
    />,
  ],
  'FeaturedImage',
  24
);

export const FestivalIcon = createSvgIcon(
  [
    <g stroke="currentColor" strokeMiterlimit="10" strokeWidth="2" key="0">
      <path strokeLinecap="square" d="M11 23v-4l-3-3.4L5 19v4" />
      <path d="m8 9 7 8v6" />
      <path
        strokeLinecap="square"
        d="M20 7c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3432-3 3 1.3431 3 3 3ZM1 23v-6l7-8h8l7 8v6z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Festival',
  24
);

export const FileChartBarIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M20 10V4c0-1.1046-.8954-2-2-2h-6.9216a2 2 0 0 0-1.4142.5858L4.5858 7.6642A2 2 0 0 0 4 9.0784V20c0 1.1046.8954 2 2 2h3"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M4 9h7V2"
      key="1"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M17 14v8m4-5v5m-8-3v3"
      key="2"
    />,
  ],
  'FileChartBar',
  24
);

export const FileChartPieIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M16 13v5h5"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M20 10V4c0-1.1046-.8954-2-2-2h-6.9216a2 2 0 0 0-1.4142.5858L4.5858 7.6642A2 2 0 0 0 4 9.0784V20c0 1.1046.8954 2 2 2h2"
      key="1"
    />,
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M4 9h7V2"
      key="2"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M16 23c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5-5 2.2386-5 5 2.2386 5 5 5Z"
      key="3"
    />,
  ],
  'FileChartPie',
  24
);

export const FileIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M11.0784 2H18c1.1046 0 2 .8954 2 2v16c0 1.1046-.8954 2-2 2H6c-1.1046 0-2-.8954-2-2V9.0784a2 2 0 0 1 .5858-1.4142l5.0784-5.0784A2 2 0 0 1 11.0784 2Z"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M4 9h7V2"
      key="1"
    />,
  ],
  'File',
  24
);

export const FilterAltIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    d="M3 7h10m-2 10h10m-3.5-6.5c1.933 0 3.5-1.567 3.5-3.5s-1.567-3.5-3.5-3.5S14 5.067 14 7s1.567 3.5 3.5 3.5m-11 10c1.933 0 3.5-1.567 3.5-3.5s-1.567-3.5-3.5-3.5S3 15.067 3 17s1.567 3.5 3.5 3.5"
  />,
  'FilterAlt',
  24
);

export const FilterIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    d="M6 12h12M3 6h18M10 18h4"
  />,
  'Filter',
  24
);

export const FlashlightIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeWidth="2"
      d="m9 9.2637-2-4V2h10v3.2637l-2 4V19c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3z"
      key="0"
    />,
    <rect
      width="2"
      height="4"
      x="11"
      y="13"
      fill="currentColor"
      rx="1"
      key="1"
    />,
    <path fill="currentColor" d="M9 9h6v2H9zM7 5h10v2H7z" key="2" />,
  ],
  'Flashlight',
  24
);

export const FolderClosedIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="square"
    strokeMiterlimit="10"
    strokeWidth="2"
    d="M2 5v13c0 1.1046.8954 2 2 2h16c1.1046 0 2-.8954 2-2V8c0-1.1046-.8954-2-2-2h-7l-3-3H4c-1.1046 0-2 .8954-2 2Z"
  />,
  'FolderClosed',
  24
);

export const FolderEditIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="square"
    strokeMiterlimit="10"
    strokeWidth="2"
    d="M9 20H4c-1.1046 0-2-.8954-2-2V5c0-1.1046.8954-2 2-2h6l3 3h7c1.1046 0 2 .8954 2 2m-6 13.5 6-6c.8284-.8284.8284-2.1716 0-3s-2.1716-.8284-3 0l-6 6v3z"
  />,
  'FolderEdit',
  24
);

export const FolderOpenIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M2 18.4613V5c0-1.1046.8954-2 2-2h5.6l2.85 2.8235H18c1.1046 0 2 .8955 2 2V10"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M17.1458 20H3.509c-1.0612 0-1.7869-1.0718-1.3928-2.0571L5.2934 10H22.5l-3.4971 8.7428A2 2 0 0 1 17.1458 20Z"
      key="1"
    />,
  ],
  'FolderOpen',
  24
);

export const GiftcardIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M1 16h22m-2 5H3c-1.105 0-2-.6961-2-1.5556V8.5556C1 7.696 1.895 7 3 7h18c1.105 0 2 .6961 2 1.5556v10.8888C23 20.3039 22.105 21 21 21"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M4 4.5A2.587 2.587 0 0 1 6.667 2C10.611 2 12 7 12 7H6.667A2.587 2.587 0 0 1 4 4.5M17.333 7H12s1.389-5 5.333-5A2.5873 2.5873 0 0 1 20 4.5 2.587 2.587 0 0 1 17.333 7"
      key="1"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="2"
      d="m12.4142 7 4.2427 4.2426M12.2427 7 8 11.2425"
      key="2"
    />,
  ],
  'Giftcard',
  24
);

export const GlobeConnectIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="m18.25 15.25 4 4-4 4"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="m21.25 19.251 1-.001h-8.5"
      key="1"
    />,
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M22 12H2M12 2c2.8572 2.721 4.2857 6.3605 4.2857 10M12 22C6.2857 16.5578 6.2857 7.4422 12 2"
      key="2"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M12 22C6.4772 22 2 17.5228 2 12S6.4772 2 12 2s10 4.4772 10 10"
      key="3"
    />,
  ],
  'GlobeConnect',
  24
);

export const GlobeIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M22 12H2m10 10c5.7143-5.4422 5.7143-14.5578 0-20m0 20C6.2857 16.5578 6.2857 7.4422 12 2"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M12 22c5.5228 0 10-4.4772 10-10S17.5228 2 12 2 2 6.4772 2 12s4.4772 10 10 10Z"
      key="1"
    />,
  ],
  'Globe',
  24
);

export const GoupObjectsIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="square"
    strokeMiterlimit="10"
    strokeWidth="2"
    d="M4 22c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2Zm8-16c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2Zm0 16c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2Zm8 0c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2Zm0-8c0-1.1046-.8954-2-2-2H6c-1.1046 0-2 .8954-2 2m8-4v4"
  />,
  'GoupObjects',
  24
);

export const HallIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    d="M19 5H5v10h14zM5 5 1 2v16l4-3M19 5l4-3v16l-4-3M6 19h12M1 23h22"
  />,
  'Hall',
  24
);

export const HapticsIcon = createSvgIcon(
  [
    <g key="0">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M18.1207 14.1207a3 3 0 0 0 0-4.242m2.829 7.0718a7 7 0 0 0 2.0505-4.95 6.998 6.998 0 0 0-2.0505-4.95M5.8793 9.8808a3 3 0 0 0 0 4.242M3.0503 7.051a7 7 0 0 0 0 9.8999M18.9998 3.9998v-1a2.0003 2.0003 0 0 0-2-2h-10a2 2 0 0 0-2 2v1m0 16v1a2 2 0 0 0 2 2h10a2.0004 2.0004 0 0 0 2-2v-1"
      />
      <path
        fill="currentColor"
        d="M12 14c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Haptics',
  24
);

export const HeatIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="square"
    strokeWidth="2"
    d="M14 9s1.0882-4.5795-2.5-7h-.5064c-.3296 5.391-7.0488 7.1565-6.9933 12.9255C3.9788 17.7787 5.5267 20.6178 8.0001 22H8.5c.1821-2.5284 3-2.8251 3-6h.5c2.1562 1.2462 3.3752 3.5158 3.5001 6h.5c2.5048-1.1334 3.8795-3.6804 3.9948-6.4346.0706-2.3349-.586-4.6239-1.8646-6.5654"
  />,
  'Heat',
  24
);

export const HeatmapIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="square"
    strokeMiterlimit="10"
    strokeWidth="2"
    d="M9 3v18m6-18v18m6-12H3m18 6H3m18 4V5c0-1.1046-.8954-2-2-2H5c-1.1046 0-2 .8954-2 2v14c0 1.1046.8954 2 2 2h14c1.1046 0 2-.8954 2-2Z"
  />,
  'Heatmap',
  24
);

export const HelpIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M12 22c5.5228 0 10-4.4772 10-10S17.5228 2 12 2 2 6.4772 2 12s4.4772 10 10 10Z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M12 18.5c.6904 0 1.25-.5596 1.25-1.25S12.6904 16 12 16s-1.25.5596-1.25 1.25.5596 1.25 1.25 1.25"
      key="1"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M9.244 8.369c.422-1.608 1.733-2.44 3.201-2.364 1.45.075 2.799.872 2.737 2.722-.089 2.63-2.884 2.273-3.197 4.773h.011"
      key="2"
    />,
  ],
  'Help',
  24
);

export const HideIcon = createSvgIcon(
  [
    <g stroke="currentColor" strokeMiterlimit="10" strokeWidth="2" key="0">
      <path d="M9.608 14.392C8.054 13.544 7 11.895 7 10c0-2.761 2.239-5 5-5 1.895 0 3.544 1.054 4.392 2.608" />
      <path d="M6.521 17.479C2.954 15.42 1.141 12 1.141 12S5 5 12 5c2.107 0 3.943.634 5.479 1.521" />
      <path
        strokeLinecap="square"
        d="M20.647 9.009C22.185 10.574 22.859 12 22.859 12S19 19 12 19c-.433 0-.855-.027-1.265-.077M22 2 2 22"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Hide',
  24
);

export const HistoryIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M12 7v5l4 4M3.5 3.5v4h4"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M2.5 12c0 5.2467 4.2533 9.5 9.5 9.5s9.5-4.2533 9.5-9.5-4.2533-9.5-9.5-9.5c-3.6186 0-6.7646 2.0231-8.3687 5l.1046-.189"
      key="1"
    />,
  ],
  'History',
  24
);

export const HomeIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeWidth="2"
    d="M18 3c1.6569 0 3 1.3431 3 3s-1.3431 3-3 3-3-1.3431-3-3 1.3431-3 3-3ZM6 3c1.6569 0 3 1.3431 3 3S7.6569 9 6 9 3 7.6569 3 6s1.3431-3 3-3Zm12 12c1.6569 0 3 1.3431 3 3s-1.3431 3-3 3-3-1.3431-3-3 1.3431-3 3-3ZM6 15c1.6569 0 3 1.3431 3 3s-1.3431 3-3 3-3-1.3431-3-3 1.3431-3 3-3Z"
  />,
  'Home',
  24
);

export const HouseIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="m1 11 11-9 11 9"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M5 13v7c0 1.105.895 2 2 2h10c1.105 0 2-.895 2-2v-7m-7 9v-4"
      key="1"
    />,
  ],
  'House',
  24
);

export const InfoSimpleIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12 10v10"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M12 6c.8284 0 1.5-.6716 1.5-1.5S12.8284 3 12 3s-1.5.6716-1.5 1.5S11.1716 6 12 6"
      key="1"
    />,
  ],
  'InfoSimple',
  24
);

export const InfoIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12 22c5.5228 0 10-4.4772 10-10S17.5228 2 12 2 2 6.4772 2 12s4.4772 10 10 10"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12 17v-6"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M12 6c-.6904 0-1.25.5596-1.25 1.25S11.3096 8.5 12 8.5s1.25-.5596 1.25-1.25S12.6904 6 12 6"
      key="2"
    />,
  ],
  'Info',
  24
);

export const InstagramIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M11.999 0c3.258 0 3.6659.014 4.9453.0723 1.2773.0585 2.1502.261 2.9151.5576.7899.3062 1.4575.7164 2.125 1.3838.6675.667 1.0782 1.3367 1.3857 2.126.2949.7628.4976 1.6348.5576 2.912C23.9852 8.3318 24 8.741 24 12s-.0148 3.6673-.0723 4.9473c-.06 1.2767-.2626 2.1489-.5576 2.9121-.3075.789-.7182 1.459-1.3857 2.126-.6667.6672-1.3352 1.0783-2.124 1.3847-.7635.2967-1.6367.4991-2.9141.5576-1.2798.0583-1.6882.0723-4.9473.0723-3.2583 0-3.6673-.014-4.9472-.0723-1.2772-.0585-2.1497-.2609-2.9131-.5576-.7887-.3065-1.4584-.7173-2.125-1.3847-.6673-.667-1.077-1.3368-1.3838-2.126-.2965-.763-.4989-1.6356-.5576-2.9131C.0143 15.6667 0 15.2586 0 12c0-3.259.015-3.6683.0723-4.9482.0575-1.2769.2601-2.149.5576-2.9122.3075-.789.7173-1.459 1.3848-2.126C2.6817 1.3465 3.3514.9365 4.1407.63 4.9034.3332 5.7754.1308 7.0526.0723 8.3325.014 8.7418 0 11.999 0m-1.0742 2.1592c-2.236.0025-2.6659.0174-3.7725.0674-1.1694.0537-1.8055.249-2.2285.414-.5596.218-.96.4778-1.3798.8975-.4199.4198-.68.8202-.8975 1.3799-.1643.423-.3596 1.0585-.4131 2.2285-.0575 1.265-.0693 1.6432-.0693 4.8476s.0118 3.5847.0693 4.8497c.0533 1.1697.2489 1.805.413 2.2275.218.5599.4778.9591.8976 1.3789s.8201.68 1.3798.8975c.4233.1642 1.059.36 2.2285.414 1.2647.0575 1.6458.0694 4.8497.0694 3.2031 0 3.5837-.0119 4.8486-.0694 1.1694-.0535 1.8051-.2491 2.2275-.414.56-.2175.96-.4776 1.3799-.8975.4196-.4194.6801-.8184.8975-1.3779.1642-.4225.3595-1.058.4131-2.2276.0574-1.2649.0703-1.6453.0703-4.8476 0-3.2025-.0128-3.5827-.0703-4.8477-.0533-1.1698-.2489-1.805-.4131-2.2275-.2179-.5598-.4778-.9601-.8975-1.38s-.8201-.6799-1.3799-.8974c-.4229-.1642-1.0582-.3595-2.2275-.413-1.2651-.0575-1.6455-.0694-4.8486-.0694-.4003 0-.7578-.0005-1.0772 0zm1.0762 3.6777c3.4029.0004 6.1611 2.7601 6.1611 6.1631-.0002 3.4029-2.7582 6.1609-6.1611 6.1611-3.4032 0-6.162-2.758-6.1621-6.1611s2.7588-6.163 6.1621-6.163M12 8c-2.209.0002-4 1.7909-4 4 .0001 2.2088 1.791 3.9998 4 4 2.2089 0 3.9999-1.7911 4-4 0-2.2093-1.791-4-4-4m6.4072-3.8457c.7945.0004 1.4392.645 1.4395 1.4394 0 .7948-.6448 1.44-1.4395 1.4405-.795 0-1.4404-.6455-1.4404-1.4405.0002-.7453.5672-1.358 1.293-1.4316z"
  />,
  'Instagram',
  24
);

export const KeyboardIcon = createSvgIcon(
  [
    <g key="0">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M21 11H3c-1.1046 0-2 .8954-2 2v8c0 1.1046.8954 2 2 2h18c1.1046 0 2-.8954 2-2v-8c0-1.1046-.8954-2-2-2M4 15h1m4 0h1m4 0h1m4 0h1M4 19h1m4 0h6m4 0h1"
      />
      <path
        fill="currentColor"
        d="M12 .6c.211 0 .422.067.6.2l4.8 3.6L16.2 6 12 2.85 7.8 6 6.6 4.4 11.4.8c.178-.133.389-.2.6-.2"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Keyboard',
  24
);

export const KioskIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M12 8c-.829 0-1.5-.671-1.5-1.5S11.171 5 12 5s1.5.671 1.5 1.5S12.829 8 12 8Z"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="m10.5 23-.5-5-2-1 .914-4.571c.055-.273.218-.522.459-.662q2.6265-1.533 5.253 0c.241.141.404.389.459.662L15.999 17l-2 1-.5 5z"
      key="1"
    />,
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M2 24V3c0-1.1046.8954-2 2-2h16c1.1046 0 2 .8954 2 2v21"
      key="2"
    />,
  ],
  'Kiosk',
  24
);

export const LaunchIcon = createSvgIcon(
  [
    <g stroke="currentColor" strokeMiterlimit="10" strokeWidth="2" key="0">
      <path d="M10.001 7H6.963c-.608 0-1.183.277-1.563.752l-3.602 4.51 4.553 1.089M17 13.999v3.038c0 .608-.277 1.183-.752 1.563l-4.51 3.602-1.089-4.553" />
      <path
        fill="currentColor"
        strokeLinecap="square"
        d="M15.5 9a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"
      />
      <path
        strokeLinecap="square"
        d="M4.402 16.95c-.31.153-.62.372-.918.67C2.323 18.781 2 22 2 22s3.22-.324 4.38-1.484c.297-.297.516-.6081.67-.9181m3.599-1.9489C16.411 16.066 21.213 11.145 22 2c-9.145.786-14.067 5.588-15.649 11.351l4.299 4.299z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Launch',
  24
);

export const LayoutCollapseIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="square"
    strokeMiterlimit="10"
    strokeWidth="2"
    d="M20 4H4c-1.1046 0-2 .8954-2 2v12c0 1.1046.8954 2 2 2h16c1.1046 0 2-.8954 2-2V6c0-1.1046-.8954-2-2-2ZM8 18V6"
  />,
  'LayoutCollapse',
  24
);

export const LightmodeIcon = createSvgIcon(
  [
    <g stroke="currentColor" strokeMiterlimit="10" strokeWidth="2" key="0">
      <path
        strokeLinecap="square"
        d="M12 17c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5-5 2.2386-5 5 2.2386 5 5 5Z"
      />
      <path
        strokeLinecap="round"
        d="M12 1v2m7.778 1.222-1.414 1.414M23 12h-2m-1.222 7.778-1.414-1.414M12 23v-2m-7.778-1.222 1.414-1.414M1 12h2m1.222-7.778 1.414 1.414"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Lightmode',
  24
);

export const LockedIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M19 9H5c-1.1046 0-2 .8954-2 2v10c0 1.1046.8954 2 2 2h14c1.1046 0 2-.8954 2-2V11c0-1.1046-.8954-2-2-2Z"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M12 18c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2Zm5-11V6a4.951 4.951 0 0 0-4.9-5H12a4.951 4.951 0 0 0-5 4.9V7"
      key="1"
    />,
  ],
  'Locked',
  24
);

export const LogoIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="square"
    strokeMiterlimit="10"
    strokeWidth="2"
    d="m2.0001 21 5-8 3 4 5.5-9.5L22 21zM6.5 8C7.8807 8 9 6.8807 9 5.5S7.8807 3 6.5 3 4 4.1193 4 5.5 5.1193 8 6.5 8Z"
  />,
  'Logo',
  24
);

export const MapPinIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M15.5 13.5v8-.5m-7-7.5V18v-.5M19.9648 4.2828 22 3.5V19l-6.5 2.5-7-3.5L2 20.5V5l2.0422-.7855"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M12 10.75c2.328-1.656 4-3.541 4-5.75s-1.791-4-4-4-4 1.791-4 4 1.672 4.094 4 5.75Z"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M12 6.25c.6904 0 1.25-.5596 1.25-1.25S12.6904 3.75 12 3.75s-1.25.5596-1.25 1.25.5596 1.25 1.25 1.25"
      key="2"
    />,
  ],
  'MapPin',
  24
);

export const MegaphoneIcon = createSvgIcon(
  [
    <g key="0">
      <path
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="m10.493 14.389 2.362 5.863a2 2 0 0 1-1.108 2.6 1.9996 1.9996 0 0 1-2.6-1.108L5.511 12.8"
      />
      <path
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M18.309 1.119 3 6a2.82 2.82 0 0 0-2 3 2.82 2.82 0 0 0 2 3l15.309 4.881"
      />
      <path
        stroke="currentColor"
        strokeLinecap="square"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M19 17c2.2091 0 4-3.5817 4-8s-1.7909-8-4-8-4 3.5817-4 8 1.7909 8 4 8Z"
      />
      <path
        fill="currentColor"
        d="M20 9a2.9904 2.9904 0 0 0-2.658-2.966A12.55 12.55 0 0 0 17 9a12.55 12.55 0 0 0 .342 2.9661A2.99 2.99 0 0 0 20 9.0001"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Megaphone',
  24
);

export const MembershipRenewalOnIcon = createSvgIcon(
  [
    <g key="0">
      <path
        stroke="currentColor"
        strokeLinecap="square"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="m16 19 2 2 5-5"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M15 10h4"
      />
      <path
        fill="currentColor"
        d="M4 16c0-1.657 1.343-3 3-3h2c1.657 0 3 1.343 3 3z"
      />
      <path
        stroke="currentColor"
        strokeLinecap="square"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M11 21H3.2C1.985 21 1 19.9927 1 18.75V5.25C1 4.0074 1.985 3 3.2 3h17.6C22.0151 3 23 4.0074 23 5.25V12"
      />
      <path
        fill="currentColor"
        d="M8 12c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'MembershipRenewalOn',
  24
);

export const MembershipRenewalIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M15 9h4"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M4 15c0-1.657 1.343-3 3-3h2c1.657 0 3 1.343 3 3z"
      key="1"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M10 20H3.2C1.985 20 1 18.9927 1 17.75V4.25C1 3.0074 1.985 2 3.2 2h17.6C22.0151 2 23 3.0074 23 4.25V9"
      key="2"
    />,
    <path
      fill="currentColor"
      d="M8 11c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2"
      key="3"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M23 13v4h-4"
      key="4"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M20.8121 21.6c-.752.565-1.687.9-2.7.9-2.485 0-4.5-2.015-4.5-4.5s2.015-4.5 4.5-4.5c2.142 0 3.934 1.496 4.388 3.5h-.388"
      key="5"
    />,
  ],
  'MembershipRenewal',
  24
);

export const MembershipIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M15 10h4m-4 4h4"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M4 16c0-1.657 1.343-3 3-3h2c1.657 0 3 1.343 3 3z"
      key="1"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M1 5.25v13.5C1 19.9927 1.985 21 3.2 21h17.6c1.2151 0 2.2-1.0073 2.2-2.25V5.25C23 4.0074 22.0151 3 20.8 3H3.2C1.985 3 1 4.0074 1 5.25Z"
      key="2"
    />,
    <path
      fill="currentColor"
      d="M8 12c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2"
      key="3"
    />,
  ],
  'Membership',
  24
);

export const MenuIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="square"
    strokeMiterlimit="10"
    strokeWidth="2"
    d="M2 12h20M2 6h20M2 18h20"
  />,
  'Menu',
  24
);

export const MicrophoneIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="m14.1924 14.0502-7.7782 6.364L5 19l-1.4142-1.4142 6.364-7.7782"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="m3 22-.5-.5L2 21m9.5-8.5c2.3432 2.3431 6.1421 2.3431 8.4853 0 2.3431-2.3431 2.3431-6.1422 0-8.4853s-6.1421-2.3432-8.4853 0c-2.3431 2.3431-2.3431 6.1422 0 8.4853Z"
      key="1"
    />,
  ],
  'Microphone',
  24
);

export const MoneyBillsIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M1 7v14h22V7z"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M12 16.5c1.3807 0 2.5-1.1193 2.5-2.5s-1.1193-2.5-2.5-2.5-2.5 1.1193-2.5 2.5 1.1193 2.5 2.5 2.5ZM5 17h1m12-6h1M4 3h16"
      key="1"
    />,
  ],
  'MoneyBills',
  24
);

export const MoreHorizontalIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M10.25 12c0 .9665.7835 1.75 1.75 1.75s1.75-.7835 1.75-1.75-.7835-1.75-1.75-1.75-1.75.7835-1.75 1.75m7.25 0c0 .9665.7835 1.75 1.75 1.75S21 12.9665 21 12s-.7835-1.75-1.75-1.75-1.75.7835-1.75 1.75M3 12c0 .9665.7835 1.75 1.75 1.75S6.5 12.9665 6.5 12s-.7835-1.75-1.75-1.75S3 11.0335 3 12"
  />,
  'MoreHorizontal',
  24
);

export const MoreIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M12 13.75c.9665 0 1.75-.7835 1.75-1.75s-.7835-1.75-1.75-1.75-1.75.7835-1.75 1.75.7835 1.75 1.75 1.75m0-7.25c.9665 0 1.75-.7835 1.75-1.75S12.9665 3 12 3s-1.75.7835-1.75 1.75S11.0335 6.5 12 6.5M12 21c.9665 0 1.75-.7835 1.75-1.75S12.9665 17.5 12 17.5s-1.75.7835-1.75 1.75S11.0335 21 12 21"
  />,
  'More',
  24
);

export const MusicIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M11 3s7.625 0 10 7c-3.667-2.167-10-2-10-2m0-7v18"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M7 23c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4-4 1.7909-4 4 1.7909 4 4 4Z"
      key="1"
    />,
  ],
  'Music',
  24
);

export const NearMeIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M12 4c-.829 0-1.5-.671-1.5-1.5S11.171 1 12 1s1.5.671 1.5 1.5S12.829 4 12 4Z"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M5.934 15.825C3.547 16.556 2 17.704 2 19c0 2.209 4.477 4 10 4s10-1.791 10-4c0-1.296-1.547-2.444-3.934-3.175"
      key="1"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="m10.5 19-.5-5-2-1 .914-4.571c.055-.273.218-.522.459-.662q2.6265-1.533 5.253 0c.241.141.404.389.459.662L15.999 13l-2 1-.5 5z"
      key="2"
    />,
  ],
  'NearMe',
  24
);

export const NewSeatsIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M8 17v3M6 9V5c0-1.1046.8954-2 2-2h8c1.1046 0 2 .8954 2 2v4M4 21v-6c0-1.1046.8954-2 2-2h4m12 .5V17h-3.5M12 22.5V19h3.5"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M20.854 17h.388c-.454-2.004-2.246-3.5-4.388-3.5-1.3326 0-2.53.5794-3.354 1.5m-.354 4h-.388c.454 2.004 2.246 3.5 4.388 3.5 1.3326 0 2.53-.5794 3.354-1.5"
      key="1"
    />,
  ],
  'NewSeats',
  24
);

export const NoteIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M12.9216 22H6c-1.1046 0-2-.8954-2-2V4c0-1.1046.8954-2 2-2h12c1.1046 0 2 .8954 2 2v10.9216a2 2 0 0 1-.5858 1.4142l-5.0784 5.0784A2 2 0 0 1 12.9216 22Z"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M20 15h-7v7"
      key="1"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M8 11h8M8 7h3m4 0h1"
      key="2"
    />,
  ],
  'Note',
  24
);

export const NotificationIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M22 18c-1.657 0-3-1.343-3-3V9c0-3.866-3.134-7-7-7S5 5.134 5 9v6c0 1.657-1.343 3-3 3z"
      key="0"
    />,
    <path
      fill="currentColor"
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M10.277 22c.346.595.984 1 1.723 1s1.376-.405 1.723-1z"
      key="1"
    />,
  ],
  'Notification',
  24
);

export const PaintBucketIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M20 15c1.455 1.104 2.5 2.3607 2.5 3.8333S21.3806 21.5 20 21.5s-2.5-1.194-2.5-2.6667c0-1.4726 1.045-2.7293 2.5-3.8333Z"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M17.5 11.9999h-3.6073c-2.894 0-5.7535-.6281-8.3811-1.8408l-2.1282-.9822"
      key="1"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M19 10.4853 10.5147 2l-8.4852 8.4853c-.7811.781-.7811 2.0474 0 2.8284l5.6568 5.6569c.781.781 2.0474.781 2.8284 0z"
      key="2"
    />,
  ],
  'PaintBucket',
  24
);

export const PaintbrushIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M13 3H5c-1.1046 0-2 .8954-2 2v14c0 1.1046.8954 2 2 2h14c1.1046 0 2-.8954 2-2v-8"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M14.5647 13.6587C13.0604 15.1629 8.9807 15 8.9807 15s-.1671-4.0755 1.3413-5.584c1.3989-1.3988 3.2815-1.1068 4.3155-.0728s1.3261 2.9166-.0728 4.3155Z"
      key="1"
    />,
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="m15.1319 10.1923 5.7563-4.1864c1.0617-.772 1.1823-2.31.2541-3.2382s-2.4661-.8075-3.2382.254l-4.1864 5.7564"
      key="2"
    />,
  ],
  'Paintbrush',
  24
);

export const PaperPlaneIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M21.5 2.5 7 12.875V21l5-4.375"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="m2.5 9.5 19-7-3 19z"
      key="1"
    />,
  ],
  'PaperPlane',
  24
);

export const PhoneAddIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M17 7V3c0-1.1046-.8954-2-2-2H5c-1.1046 0-2 .8954-2 2v16c0 1.1046.8954 2 2 2h3"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M17 15v4m-2-2h4"
      key="1"
    />,
    <circle
      cx="17"
      cy="17"
      r="6"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      key="2"
    />,
  ],
  'PhoneAdd',
  24
);

export const PhoneCameraIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M7 22h10c1.1046 0 2-.8954 2-2V4c0-1.1046-.8954-2-2-2H7c-1.1046 0-2 .8954-2 2v16c0 1.1046.8954 2 2 2Z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M9.25 7.5c.6904 0 1.25-.5596 1.25-1.25S9.9404 5 9.25 5 8 5.5596 8 6.25 8.5596 7.5 9.25 7.5m0 4c.6904 0 1.25-.5596 1.25-1.25S9.9404 9 9.25 9 8 9.5596 8 10.25s.5596 1.25 1.25 1.25"
      key="1"
    />,
  ],
  'PhoneCamera',
  24
);

export const PhoneRemoveIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M17 7V3c0-1.1046-.8954-2-2-2H5c-1.1046 0-2 .8954-2 2v16c0 1.1046.8954 2 2 2h3"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M15 17h4"
      key="1"
    />,
    <circle
      cx="17"
      cy="17"
      r="6"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      key="2"
    />,
  ],
  'PhoneRemove',
  24
);

export const PhoneIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M17 2H7c-1.1045 0-2 .8954-2 2v16c0 1.1046.8955 2 2 2h10c1.1046 0 2-.8954 2-2V4c0-1.1046-.8954-2-2-2Z"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M13.4397 5.1206h-2.8794a.0603.0603 0 0 1 0-.1206h2.8794a.0603.0603 0 0 1 0 .1206Z"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M12 19c.6904 0 1.25-.5596 1.25-1.25S12.6904 16.5 12 16.5s-1.25.5596-1.25 1.25S11.3096 19 12 19"
      key="2"
    />,
  ],
  'Phone',
  24
);

export const PinIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 1 1 18 0"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M12 13c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3"
      key="1"
    />,
  ],
  'Pin',
  24
);

export const PointsIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="square"
    strokeMiterlimit="10"
    strokeWidth="2"
    d="M12 5c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2Zm0 18c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2Zm0-9c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2Zm6.0622-5.5c.5523.9566 1.7755 1.2843 2.7321.732s1.2843-1.7754.732-2.732-1.7755-1.2844-2.732-.732c-.9566.5522-1.2844 1.7754-.7321 2.732Zm-15.5885 9c.5523.9566 1.7755 1.2843 2.732.732s1.2844-1.7754.7321-2.732-1.7755-1.2843-2.732-.7321-1.2844 1.7755-.7321 2.7321Zm15.5885-2c-.5523.9566-.2245 2.1798.7321 2.732s2.1797.2246 2.732-.732.2245-2.1798-.732-2.7321-2.1798-.2245-2.7321.7321Zm-15.5885-9c-.5523.9566-.2245 2.1797.732 2.732s2.1798.2246 2.7321-.732.2245-2.1798-.732-2.732c-.9566-.5524-2.1798-.2246-2.7321.732Z"
  />,
  'Points',
  24
);

export const PosterIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="m8 22 7.5-8.5L19 17"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M10.5 10c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2Z"
      key="1"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M19 20V4c0-1.1046-.8954-2-2-2H7c-1.1046 0-2 .8954-2 2v16c0 1.1046.8954 2 2 2h10c1.1046 0 2-.8954 2-2Z"
      key="2"
    />,
  ],
  'Poster',
  24
);

export const PrinterIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M6 18H2v-8c0-1.1046.8955-2 2-2h16c1.1046 0 2 .8954 2 2v8h-4M6 4.1015V2h12v2.1434"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M18 14H6v8h12z"
      key="1"
    />,
  ],
  'Printer',
  24
);

export const ProductsIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M18 1a1 1 0 0 1 .707.293l4 5A1 1 0 0 1 23 7v15c0 .5523-.4477 1-1 1H2c-.5523 0-1-.4477-1-1V7a1 1 0 0 1 .293-.707l4-5A1 1 0 0 1 6 1zm2.5664 5.8535c-.1362.0921-.2957.1465-.4668.1465H3.9004c-.1714 0-.3314-.054-.4678-.1465L3 7.4141V21h18V7.414zM4.8672 5h14.2656l-1.5469-2H6.4141z"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8 10c.5523 0 1 .4477 1 1 0 1.6877 1.3123 3 3 3s3-1.3123 3-3c0-.5523.4477-1 1-1s1 .4477 1 1c0 2.7923-2.2077 5-5 5s-5-2.2077-5-5c0-.5523.4477-1 1-1"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'Products',
  24
);

export const ProfileIcon = createSvgIcon(
  [
    <g
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      key="0"
    >
      <path d="m18 14 4 2 .674 4.717c.172 1.205-.763 2.283-1.98 2.283H3.306c-1.217 0-2.152-1.078-1.98-2.283L2 16l4-2m11-8c0-2.7614-2.2386-5-5-5S7 3.2386 7 6v2c0 2.7614 2.2386 5 5 5s5-2.2386 5-5z" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Profile',
  24
);

export const ProtectedIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M8 12.75 10.25 15 16 8.75"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M12 22s9-2 9-11V4c-3.203 0-6.11-.731-9-2-2.89 1.269-5.797 2-9 2v7c0 9 9 11 9 11Z"
      key="1"
    />,
  ],
  'Protected',
  24
);

export const QuestionIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M12 22c5.5228 0 10-4.4772 10-10S17.5228 2 12 2 2 6.4772 2 12s4.4772 10 10 10Z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M12 18.5c.6904 0 1.25-.5596 1.25-1.25S12.6904 16 12 16s-1.25.5596-1.25 1.25.5596 1.25 1.25 1.25"
      key="1"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M9.244 8.369c.422-1.608 1.733-2.44 3.201-2.364 1.45.075 2.799.872 2.737 2.722-.089 2.63-2.884 2.273-3.197 4.773h.011"
      key="2"
    />,
  ],
  'Question',
  24
);

export const RadiusIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12 21v-6.5m9-2.5h-6.5M12 14c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="2"
      d="M21 3h-9c-4.9705 0-9 4.0295-9 9v9"
      key="1"
    />,
  ],
  'Radius',
  24
);

export const ReceiptIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="square"
    strokeMiterlimit="10"
    strokeWidth="2"
    d="M8 7h3m-3 4h3m-3 4h3m4-8h1m-1 4h1m-1 4h1m2-13H6c-1.1046 0-2 .8954-2 2v17.5L8 20l4 2 4-2 4 1.5V4c0-1.1046-.8954-2-2-2Z"
  />,
  'Receipt',
  24
);

export const RefundIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M2 9h20m0 0V6c0-1.1046-.8954-2-2-2H4c-1.1046 0-2 .8954-2 2v12c0 1.1046.8954 2 2 2h4m-2-4h2m14-3v3.5h-3.5M12 22v-3.5h3.5"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M20.854 16.5h.388c-.454-2.004-2.246-3.5-4.388-3.5-1.3325 0-2.5299.5794-3.3539 1.5m-.3541 4h-.388c.454 2.004 2.246 3.5 4.388 3.5 1.3325 0 2.5299-.5794 3.3539-1.5"
      key="1"
    />,
  ],
  'Refund',
  24
);

export const RemoveCircleIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12 22c5.5228 0 10-4.4772 10-10S17.5228 2 12 2 2 6.4772 2 12s4.4772 10 10 10"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="2"
      d="M8 12h8"
      key="1"
    />,
  ],
  'RemoveCircle',
  24
);

export const RemoveIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    d="M17.3137 12H6"
  />,
  'Remove',
  24
);

export const RenameIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M2 21h20"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="m13 4 4 4"
      key="1"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="m9 16-5 1 1-5 9.168-9.168c1.105-1.105 2.895-1.105 4 0s1.105 2.895 0 4z"
      key="2"
    />,
  ],
  'Rename',
  24
);

export const ReportingIcon = createSvgIcon(
  [
    <circle
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="2"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M12 14V8m4 6v-4m-8 4v-2"
      key="1"
    />,
  ],
  'Reporting',
  24
);

export const RomanceIcon = createSvgIcon(
  [
    <g stroke="currentColor" strokeMiterlimit="10" strokeWidth="2" key="0">
      <path d="m23.0001 1-4.5 4.5" />
      <path
        strokeLinecap="square"
        d="M23 1v2l-1.5-.5L21 1zM11.5 21c2.1071-.9412 9.5-6.1572 9.5-10.9384C21 7.2663 18.7086 5 15.8852 5c-1.862 0-3.2528 1.1558-4.3852 2.4527C10.3695 6.154 8.9768 5 7.1148 5 4.2895 5 2 7.2664 2 10.0616 2 14.8428 9.3929 20.0588 11.5 21Z"
      />
      <path strokeLinecap="square" d="m11 13-7 7 .319-.319M1 20h3v3" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Romance',
  24
);

export const RotateClockwiseIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M20.5 2.5v5h-5"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M21.923 13.5958c.0887-.5451-.2814-1.0589-.8265-1.1475s-1.0589.2814-1.1475.8265l.987.1605zm-.987-.1605-.987-.1605c-.2969 1.8256-1.2217 3.4937-2.6187 4.7195l.6595.7517.6596.7516c1.7446-1.5308 2.9021-3.6163 3.2736-5.9018zm-2.9462 5.3107-.6595-.7517c-1.3971 1.2259-3.1798 1.9334-5.0446 2.0005l.036.9993.0359.9994c2.3238-.0836 4.5474-.9652 6.2918-2.4959zm-5.6681 2.2481-.036-.9993c-1.8647.067-3.6945-.5105-5.1774-1.633l-.6036.7973-.6035.7973c1.851 1.4012 4.1327 2.1206 6.4564 2.0371zm-5.817-1.835.6036-.7973c-1.4828-1.1225-2.5268-2.72-2.9557-4.5196l-.9728.2318-.9727.2319c.5369 2.2526 1.843 4.2493 3.6941 5.6505zM3.1798 14.074l.9728-.2318a7.948 7.948 0 0 1 .601-5.3534l-.8973-.4414-.8973-.4415a9.948 9.948 0 0 0-.752 6.7zm.6765-6.0266.8973.4414c.8178-1.6621 2.191-2.9926 3.8872-3.7632l-.4137-.9105-.4136-.9104C5.698 3.8659 3.982 5.5267 2.959 7.6059zM8.2272 3.815l.4136.9105a8.112 8.112 0 0 1 5.4133-.4597l.2539-.9672.254-.9673a10.112 10.112 0 0 0-6.7485.5733zm6.0808-.5164-.2539.9672c1.8037.4735 3.385 1.5535 4.4753 3.0543l.809-.5878.809-.5877c-1.3627-1.8759-3.337-3.223-5.5854-3.8133z"
      key="1"
    />,
  ],
  'RotateClockwise',
  24
);

export const RulerIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M18 19v-3m-5 3v-3m-5 3v-3"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M13 6v3M7.5 9H23v10H6c-2.2091 0-4-1.7909-4-4V6"
      key="1"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M7.5 9C10.5376 9 13 7.6569 13 6s-2.4624-3-5.5-3S2 4.3431 2 6s2.4624 3 5.5 3Z"
      key="2"
    />,
  ],
  'Ruler',
  24
);

export const SantaIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M17 17.7643V14M2.013 9.9998C2.273 4.9856 6.421 1 11.5 1c5.2467 0 9.5 4.2533 9.5 9.5v7.2643"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M17 10H1v4h16zm2 13c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3Z"
      key="1"
    />,
  ],
  'Santa',
  24
);

export const ScrollVerticalIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="square"
    strokeMiterlimit="10"
    strokeWidth="2"
    d="M4 9.0001v-6 .5m0 11.5v6V20.5m8-7.5V3.4999c0-.8284.6716-1.5 1.5-1.5s1.5.6716 1.5 1.5v5.5l5.5876 1.3476c1.5259.3679 2.5101 1.8498 2.2576 3.399L21.4999 22h-9.5v-2a3 3 0 0 0-.5999-1.8l-2-2.6668a2 2 0 0 1-.4-1.2V11c0-1.1046.8954-2 2-2h.5m-5-3.5L4 3 1.5 5.5m0 13.0001 2.5 2.5 2.5-2.5"
  />,
  'ScrollVertical',
  24
);

export const SearchIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    d="m21 21-5.344-5.344M10 17c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7"
  />,
  'Search',
  24
);

export const SeatLockIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="square"
    strokeMiterlimit="10"
    strokeWidth="2"
    d="M3 21v-6m4 4v-1m7.2-7H4.8c-.4774 0-.9352.1686-1.2728.4686S3 12.1757 3 12.6V15h9m5-7V4.6667c0-.442-.1806-.866-.5021-1.1785S15.7404 3 15.2857 3H6.7143c-.4547 0-.8907.1756-1.2122.4882S5 4.2246 5 4.6667V8m17 10h-7c-.5523 0-1 .4477-1 1v3c0 .5523.4477 1 1 1h7c.5523 0 1-.4477 1-1v-3c0-.5523-.4477-1-1-1Zm-6 0v-2.5c0-1.381 1.119-2.5 2.5-2.5s2.5 1.119 2.5 2.5V18"
  />,
  'SeatLock',
  24
);

export const SeatIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="square"
    strokeMiterlimit="10"
    strokeWidth="2"
    d="M4 21v-6m16 6v-6M8 19v-1m8 1v-1M5.8 11h12.4c.4774 0 .9352.1686 1.2728.4686S20 12.1757 20 12.6V15H4v-2.4c0-.4243.1896-.8313.5272-1.1314S5.3226 11 5.8 11ZM18 8V4.6667c0-.442-.1806-.866-.5021-1.1785S16.7404 3 16.2857 3H7.7143c-.4547 0-.8907.1756-1.2122.4882S6 4.2246 6 4.6667V8"
  />,
  'Seat',
  24
);

export const SectionsIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="square"
    strokeMiterlimit="10"
    strokeWidth="2"
    d="M3 9h18V3H3zm0 8h18v-4H3zm18 4H3"
  />,
  'Sections',
  24
);

export const SelectAreaIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="square"
    strokeMiterlimit="10"
    strokeWidth="2"
    d="M3 5v-.5C3 3.6716 3.6716 3 4.5 3H5m14 0h.5c.8284 0 1.5.6716 1.5 1.5V5M5 21h-.5c-.8284 0-1.5-.6716-1.5-1.5V19M3 9v1m0 4v1m18-6v1M10 3H9m6 0h-1m-4 18H9m12 0-4.3423-4.3423L17 17m2.5105-3.146L10.9999 11l2.8538 8.5108z"
  />,
  'SelectArea',
  24
);

export const SellTicketsIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeWidth="2"
      d="M19.25 18h1.25c.828 0 1.5-.672 1.5-1.5v-3.4955c-1.65 0-3-1.35-3-3 0-1.6515 1.35-3 3-3V3.5c0-.828-.672-1.5-1.5-1.5h-17C2.672 2 2 2.672 2 3.5v3.5045c1.65 0 3 1.35 3 3s-1.35 3-3 3V16.5c0 .828.672 1.5 1.5 1.5h1.25"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M8 18.0769 10.0833 20 15.5 15"
      key="1"
    />,
  ],
  'SellTickets',
  24
);

export const SettingsIcon = createSvgIcon(
  [
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      key="0"
    >
      <path d="M12 15c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3" />
      <path d="M20 12a8.05 8.05 0 0 0-.188-1.713l2.714-2.055-2-3.464-3.143 1.326a7.99 7.99 0 0 0-2.961-1.719L14 1h-4l-.422 3.375a7.99 7.99 0 0 0-2.961 1.719L3.474 4.768l-2 3.464 2.714 2.055a7.9 7.9 0 0 0 0 3.426l-2.714 2.055 2 3.464 3.143-1.326a7.99 7.99 0 0 0 2.961 1.719L10 23h4l.422-3.375a7.99 7.99 0 0 0 2.961-1.719l3.143 1.326 2-3.464-2.714-2.055A8.05 8.05 0 0 0 20 12" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Settings',
  24
);

export const ShareIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M18 15v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h3"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M9 16A10 10 0 0 1 19 6h3"
      key="1"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="m18 10 4-4-4-4"
      key="2"
    />,
  ],
  'Share',
  24
);

export const ShortcutsIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="square"
    strokeMiterlimit="10"
    strokeWidth="2"
    d="M12 10V7.5556C12 6.6964 12.6964 6 13.5556 6H17c1.1046 0 2-.8954 2-2s-.8954-2-2-2h-4c-.5523 0-1-.4477-1-1M4 22h16c1.1046 0 2-.8954 2-2v-8c0-1.1046-.8954-2-2-2H4c-1.1046 0-2 .8954-2 2v8c0 1.1046.8954 2 2 2Zm2-8h.01M10 14h.01M10 18h4m-8 0h.01M18 18h.01M14 14h.01M18 14h.01"
  />,
  'Shortcuts',
  24
);

export const ShowIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M12.0001 15c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5-5 2.2386-5 5 2.2386 5 5 5Z"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M1.1411 12s3.859-7 10.859-7 10.859 7 10.859 7-3.859 7-10.859 7-10.859-7-10.859-7Z"
      key="1"
    />,
  ],
  'Show',
  24
);

export const SoundIcon = createSvgIcon(
  [
    <g
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      key="0"
    >
      <path d="m14 22-8-6H3c-1.1046 0-2-.8954-2-2v-4c0-1.1046.8954-2 2-2h3l8-6z" />
      <path d="m14 22-8-6H3c-1.1046 0-2-.8954-2-2v-4c0-1.1046.8954-2 2-2h3l8-6zm3.5-6.5c2-2 2-5.1 0-7.1" />
      <path d="M17.5 15.5c2-2 2-5.1 0-7.1m2.9 10c3.5-3.5 3.5-9.2 0-12.7" />
      <path d="M20.4 18.4c3.5-3.5 3.5-9.2 0-12.7" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Sound',
  24
);

export const SparkleIcon = createSvgIcon(
  [
    <g key="0">
      <path
        stroke="currentColor"
        strokeWidth="2"
        d="M17.85 15.15 16.5 12l-1.35 3.15L12 16.5l3.15 1.35L16.5 21l1.35-3.15L21 16.5zm-9-9L7.5 3 6.15 6.15 3 7.5l3.15 1.35L7.5 12l1.35-3.15L12 7.5z"
      />
      <path
        fill="currentColor"
        d="M20.2 3.8 19 1l-1.2 2.8L15 5l2.8 1.2L19 9l1.2-2.8L23 5zm-14 14L5 15l-1.2 2.8L1 19l2.8 1.2L5 23l1.2-2.8L9 19z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Sparkle',
  24
);

export const StadiumIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M6.113 8A15.6 15.6 0 0 1 12 7a15.6 15.6 0 0 1 5.887 1M14 20.921V17h-4v3.921"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M12 13c6.0751 0 11-2.2386 11-5s-4.9249-5-11-5S1 5.2386 1 8s4.9249 5 11 5Z"
      key="1"
    />,
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="m23 8-1.5 9.5c0 1.933-4.253 3.5-9.5 3.5s-9.5-1.567-9.5-3.5L1 8"
      key="2"
    />,
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M7 16.481a9.9 9.9 0 0 1-5.035-2.371M17 16.481a9.9 9.9 0 0 0 5.035-2.371"
      key="3"
    />,
  ],
  'Stadium',
  24
);

export const StarIcon = createSvgIcon(
  [
    <g key="0">
      <path
        stroke="currentColor"
        strokeWidth="2"
        d="M15.7208 9a1 1 0 0 1-.9487-.6838l-1.8234-5.4701c-.3039-.9117-1.5935-.9117-1.8974 0L9.2279 8.3162A1 1 0 0 1 8.2792 9H2.9668c-.9576 0-1.3676 1.2163-.6054 1.796l4.2895 3.2623a1 1 0 0 1 .3458 1.1049L5.2009 20.691c-.2993.9213.7552 1.6874 1.5388 1.118l4.6725-3.3949a1 1 0 0 1 1.1756 0l4.6725 3.3949c.7836.5694 1.8381-.1967 1.5388-1.118l-1.7958-5.5278a1 1 0 0 1 .3458-1.1049l4.2894-3.2623c.7623-.5797.3523-1.796-.6053-1.796z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Star',
  24
);

export const StreamIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M14.121 5.879a3 3 0 0 0-4.242 0M16.95 3.05A7 7 0 0 0 12 .9995 7 7 0 0 0 7.05 3.05"
      key="0"
    />,
    <path fill="currentColor" d="M9 10v7l7-3.5z" key="1" />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M4 5H3a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1"
      key="2"
    />,
  ],
  'Stream',
  24
);

export const SwapUserIcon = createSvgIcon(
  [
    <g
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      key="0"
    >
      <path d="M5 5c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2Zm0 3c-2.209 0-4 1.791-4 4h8c0-2.209-1.791-4-4-4Zm14 8c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2Zm0 3c-2.209 0-4 1.791-4 4h8c0-2.209-1.791-4-4-4ZM4 16v2c0 .552.448 1 1 1h6" />
      <path d="m9 22 3-3-3-3m11-8V6c0-.552-.448-1-1-1h-7 1" />
      <path d="m15 2-3 3 3 3" />
    </g>,
    <defs key="1"></defs>,
  ],
  'SwapUser',
  24
);

export const TableIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="square"
    strokeMiterlimit="10"
    strokeWidth="2"
    d="M3 9h18M9 3v18m-6-6h18m0 4V5c0-1.1046-.8954-2-2-2H5c-1.1046 0-2 .8954-2 2v14c0 1.1046.8954 2 2 2h14c1.1046 0 2-.8954 2-2Z"
  />,
  'Table',
  24
);

export const TagIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M21.414 11.914 11.5 2H2v9.5l9.914 9.914c.781.781 2.047.781 2.828 0l6.672-6.672c.781-.781.781-2.047 0-2.828Z"
      key="0"
    />,
    <path
      fill="currentColor"
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M7.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"
      key="1"
    />,
  ],
  'Tag',
  24
);

export const TagsIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="m13.243 22.414 5.171-5.171a2 2 0 0 0 .5861-1.4145 2 2 0 0 0-.5861-1.4145L9 5H1v8l9.414 9.414a2 2 0 0 0 2.1801.4338 2 2 0 0 0 .6489-.4338M21 11 11 1H3"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M6 12c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2"
      key="1"
    />,
  ],
  'Tags',
  24
);

export const TextIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeWidth="2"
      d="M2.7795 15h7.4449"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeWidth="2"
      d="M1.5939 19H1.5L5.9445 5h1.111L11.5 19h-.0908"
      key="1"
    />,
    <path
      stroke="currentColor"
      strokeWidth="2"
      d="M22.9849 15.5583c-1.0044 2.3107-3.0489 3.407-4.9564 3.4412-1.3405.0241-2.728-.8147-2.9893-2.2927-.2243-1.2686.5111-2.7652 2.2702-3.2752 1.916-.5556 5.6906-.416 5.6906-.416"
      key="2"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeWidth="2"
      d="M23 19v-7.2618C23 9.6736 21.3264 8 19.2618 8a3.738 3.738 0 0 0-2.5986 1.051L16 9.6923"
      key="3"
    />,
  ],
  'Text',
  24
);

export const TheaterIcon = createSvgIcon(
  [
    <g key="0">
      <path
        stroke="currentColor"
        strokeLinecap="square"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M18 12h1M5 8h1m4 0h1m.5 13.356a7 7 0 0 0 7.4554.9836A7 7 0 0 0 23 16V6.221a21.2 21.2 0 0 0-5-1.116"
      />
      <path
        stroke="currentColor"
        strokeLinecap="square"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M1 12V2.221a20.676 20.676 0 0 1 14 0V12a7 7 0 0 1-2.0503 4.9497 6.9996 6.9996 0 0 1-9.8994 0A7 7 0 0 1 1 12Z"
      />
      <path fill="currentColor" d="M11 13a3 3 0 0 1-6 0z" />
      <path
        stroke="currentColor"
        strokeLinecap="square"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M18.121 18.879A2.99 2.99 0 0 0 16 18"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'Theater',
  24
);

export const ThumbDownIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M8 15V3"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M10.5722 21.7435 8.2762 15H3V3.5l12.6654-1.2665c1.3716-.1372 2.6601.678 3.1237 1.976l3.2565 9.1178C22.5108 14.6298 21.5452 16 20.1621 16H14l.1803 5.0801C14.2176 22.1292 13.3771 23 12.3274 23a1.854 1.854 0 0 1-1.7552-1.2565Z"
      key="1"
    />,
  ],
  'ThumbDown',
  24
);

export const ThumbUpIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M8 9v12"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M10.5722 2.2565 8.2762 9H3v11.5l12.6654 1.2665c1.3716.1372 2.6601-.6779 3.1237-1.976l3.2565-9.1178C22.5108 9.3702 21.5452 8 20.1621 8H14l.1803-5.0801C14.2176 1.8708 13.3771 1 12.3274 1a1.854 1.854 0 0 0-1.7552 1.2565Z"
      key="1"
    />,
  ],
  'ThumbUp',
  24
);

export const TicketdownloadIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeWidth="2"
      d="M19.25 18h1.25c.828 0 1.5-.672 1.5-1.5v-3.4955c-1.65 0-3-1.35-3-3 0-1.6515 1.35-3 3-3V3.5c0-.828-.672-1.5-1.5-1.5h-17C2.672 2 2 2.672 2 3.5v3.5045c1.65 0 3 1.35 3 3s-1.35 3-3 3V16.5c0 .828.672 1.5 1.5 1.5h1.25"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M12 14v8-.5m3.5-3L12 22l-3.5-3.5"
      key="1"
    />,
  ],
  'Ticketdownload',
  24
);

export const TicketIcon = createSvgIcon(
  [
    <circle cx="14.125" cy="12" r="1.125" fill="currentColor" key="0" />,
    <circle cx="14.125" cy="16" r="1.125" fill="currentColor" key="1" />,
    <circle cx="14.125" cy="8" r="1.125" fill="currentColor" key="2" />,
    <path
      stroke="currentColor"
      strokeWidth="2"
      d="M22 9.0045V4.5c0-.828-.672-1.5-1.5-1.5h-17C2.672 3 2 3.672 2 4.5v4.5045c1.65 0 3 1.35 3 3s-1.35 3-3 3V19.5c0 .828.672 1.5 1.5 1.5h17c.828 0 1.5-.672 1.5-1.5v-4.4955c-1.65 0-3-1.35-3-3 0-1.6515 1.35-3 3-3Z"
      key="3"
    />,
  ],
  'Ticket',
  24
);

export const TicketsRefundIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeWidth="2"
      d="M19.25 18h1.25c.828 0 1.5-.672 1.5-1.5v-3.4955c-1.65 0-3-1.35-3-3 0-1.6515 1.35-3 3-3V3.5c0-.828-.672-1.5-1.5-1.5h-17C2.672 2 2 2.672 2 3.5v3.5045c1.65 0 3 1.35 3 3s-1.35 3-3 3V16.5c0 .828.672 1.5 1.5 1.5h1.25"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M9.5 17.5 7 15l2.5-2.5"
      key="1"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M13 21c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3H7h1"
      key="2"
    />,
  ],
  'TicketsRefund',
  24
);

export const TilesIrregularIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="square"
    strokeMiterlimit="10"
    strokeWidth="2"
    d="M9 3H3v6h6zm6 6H9v6h6zm6 0h-6v6h6zm0 6h-6v6h6zM15 3H9v6h6zM9 15H3v6h6zm6 0H9v6h6z"
  />,
  'TilesIrregular',
  24
);

export const TransferIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="square"
    strokeMiterlimit="10"
    strokeWidth="2"
    d="M11 10c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4-4 1.7909-4 4 1.7909 4 4 4Zm2.5 3.4011A7.95 7.95 0 0 0 11 13c-4.418 0-8 3.582-8 8 3.167.792 6.3332 1.1019 9.5.95m1-3.95h8-.5m-3-3.5 3.5 3.5-3.5 3.5"
  />,
  'Transfer',
  24
);

export const TrashIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="m18.833 8-.503 12.083C18.285 21.154 17.404 22 16.332 22H7.668c-1.072 0-1.954-.845-1.998-1.917L5.167 8M10 4V3c0-.552.448-1 1-1h2c.552 0 1 .448 1 1v1"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M10 18v-6m4 6v-6M5 4h14c1.104 0 2 .896 2 2v2H3V6c0-1.104.896-2 2-2Z"
      key="1"
    />,
  ],
  'Trash',
  24
);

export const TreeIcon = createSvgIcon(
  [
    <g stroke="currentColor" strokeMiterlimit="10" strokeWidth="2" key="0">
      <path d="M8.0625 13H2L7 3l2.9 5.8001M15.9375 13H22L17 3l-2.9 5.8001" />
      <path strokeLinecap="square" d="M19 20H5l7-16zm-7 0v3" />
    </g>,
    <defs key="1"></defs>,
  ],
  'Tree',
  24
);

export const UndoIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M4 9.375h10.5c3.3827 0 5.25 2.1546 5.25 4.8125S17.8827 19 14.5 19h-4.375"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M8.375 13.75 4 9.375 8.375 5"
      key="1"
    />,
  ],
  'Undo',
  24
);

export const UnlockedIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M19 9H5c-1.1046 0-2 .8954-2 2v10c0 1.1046.8954 2 2 2h14c1.1046 0 2-.8954 2-2V11c0-1.1046-.8954-2-2-2Z"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M12 18c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2Zm4-15.033c-.893-1.181-2.305-1.95-3.9-1.967H12C9.266.973 7.028 3.166 7 5.9V7"
      key="1"
    />,
  ],
  'Unlocked',
  24
);

export const UploadIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="round"
    strokeMiterlimit="10"
    strokeWidth="2"
    d="M2 15v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4m-10 1V3m5 5-5-5-5 5"
  />,
  'Upload',
  24
);

export const UpsideDownIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M21 6v15a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12.1579 15.2105V5.4211C12.1579 2.9794 14.1373 1 16.5789 1S21 2.9794 21 5.421v4.4211"
      key="1"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="m15.3158 13-3.1579 3.1579L9 13"
      key="2"
    />,
  ],
  'UpsideDown',
  24
);

export const UrlIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="m19.014 11.943 1.021 1.021c1.953 1.953 1.953 5.118 0 7.071s-5.118 1.953-7.071 0l-3.121-3.121c-1.953-1.953-1.953-5.118 0-7.071.366-.366.775-.664 1.21-.892"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M12.934 15.056c.44-.23.853-.529 1.223-.899 1.953-1.953 1.953-5.118 0-7.071l-3.121-3.121c-1.953-1.953-5.118-1.953-7.071 0s-1.953 5.118 0 7.071l1.021 1.021"
      key="1"
    />,
  ],
  'Url',
  24
);

export const UserAltIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="m2 22 4.824-1.378A3 3 0 0 0 9 17.737V17m13 5-4.824-1.378A3 3 0 0 1 15 17.737V17"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="m17.24 12.561.609-3.656C18.451 5.291 15.664 2 12 2S5.548 5.29 6.151 8.905l.609 3.656C7.187 15.122 9.403 17 12 17s4.813-1.877 5.24-4.439Z"
      key="1"
    />,
  ],
  'UserAlt',
  24
);

export const UserEditIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="square"
    strokeMiterlimit="10"
    strokeWidth="2"
    d="M11 10c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4-4 1.7909-4 4 1.7909 4 4 4ZM8 21.847A32.85 32.85 0 0 1 3 21c0-4.418 3.582-8 8-8 .7153 0 1.407.0966 2.0653.2749M15 23l6.5-6.5c.8284-.8284.8284-2.1716 0-3s-2.1716-.8284-3 0L12 20v3z"
  />,
  'UserEdit',
  24
);

export const UserInformationIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="square"
    strokeMiterlimit="10"
    strokeWidth="2"
    d="M22 6h-5m5 4h-5m5 4h-2M9.5 10c1.933 0 3.5-1.567 3.5-3.5S11.433 3 9.5 3 6 4.567 6 6.5 7.567 10 9.5 10Zm0 3c-3.866 0-7 3.134-7 7 4.667 1.333 9.333 1.333 14 0 0-3.866-3.134-7-7-7Z"
  />,
  'UserInformation',
  24
);

export const UserTicketIcon = createSvgIcon(
  [
    <circle cx="18.1666" cy="15.75" r=".75" fill="currentColor" key="0" />,
    <circle cx="18.1666" cy="18.125" r=".75" fill="currentColor" key="1" />,
    <circle cx="18.1666" cy="20.5" r=".75" fill="currentColor" key="2" />,
    <path
      fill="currentColor"
      d="m23 16.2676.5007.8656.4993-.2888v-.5768zm0 3.4648h1v-.5768l-.4993-.2888zm-12 0-.5007-.8656-.4993.2888v.5768zm0-3.4648h-1v.5768l.4993.2888zM13 13v-1c-1.6569 0-3 1.3431-3 3h2c0-.5523.4477-1 1-1zm8 0v-1h-8v2h8zm2 2h1c0-1.6569-1.3431-3-3-3v2c.5523 0 1 .4477 1 1zm0 1.2676h1V15h-2v1.2676zM22 18h1a.999.999 0 0 1 .5007-.8668L23 16.2676l-.5007-.8656C21.6052 15.9192 21 16.8883 21 18zm1 1.7324.5007-.8656A.999.999 0 0 1 23 18h-2c0 1.1117.6052 2.0808 1.4993 2.598zM23 21h1v-1.2676h-2V21zm-2 2v1c1.6569 0 3-1.3431 3-3h-2c0 .5523-.4477 1-1 1zm-8 0v1h8v-2h-8zm-2-2h-1c0 1.6569 1.3431 3 3 3v-2c-.5523 0-1-.4477-1-1zm0-1.2676h-1V21h2v-1.2676zM12 18h-1a.999.999 0 0 1-.5007.8668l.5007.8656.5007.8656C12.3948 20.0808 13 19.1117 13 18zm-1-1.7324-.5007.8656A.999.999 0 0 1 11 18h2c0-1.1117-.6052-2.0808-1.4993-2.598zM11 15h-1v1.2676h2V15z"
      key="3"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M10 10c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4-4 1.7909-4 4 1.7909 4 4 4ZM7 21.847A32.85 32.85 0 0 1 2 21c0-2.9608 1.6089-5.5462 4-6.9296"
      key="4"
    />,
  ],
  'UserTicket',
  24
);

export const UserIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M12 6.5c1.87 0 3.326 1.621 3.127 3.48l-.084.786C14.876 12.321 13.564 13.5 12 13.5s-2.876-1.179-3.043-2.734l-.084-.786C8.674 8.121 10.131 6.5 12 6.5Z"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="m5.824 19.864.531-1.857c.091-.317.332-.577.645-.681q4.9995-1.653 9.999 0c.313.104.555.363.645.681l.531 1.857"
      key="1"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M12 22c5.5228 0 10-4.4772 10-10S17.5228 2 12 2 2 6.4772 2 12s4.4772 10 10 10Z"
      key="2"
    />,
  ],
  'User',
  24
);

export const UsersIcon = createSvgIcon(
  <path
    stroke="currentColor"
    strokeLinecap="square"
    strokeMiterlimit="10"
    strokeWidth="2"
    d="M16.5 7.5c1.5188 0 2.75-1.2312 2.75-2.75S18.0188 2 16.5 2s-2.75 1.2312-2.75 2.75S14.9812 7.5 16.5 7.5Zm-.947 9h6.422c.015-.165.025-.331.025-.5 0-3.038-2.462-5.5-5.5-5.5-.825 0-1.604.187-2.306.512M7.5 13c1.5188 0 2.75-1.2312 2.75-2.75S9.0188 7.5 7.5 7.5s-2.75 1.2312-2.75 2.75S5.9812 13 7.5 13Zm5.475 9c.015-.165.025-.331.025-.5 0-3.038-2.462-5.5-5.5-5.5S2 18.462 2 21.5c0 .169.01.335.025.5z"
  />,
  'Users',
  24
);

export const WaitlistIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M11 10c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4-4 1.7909-4 4 1.7909 4 4 4Zm-.493 3.025C6.32 13.281 3 16.748 3 21c2.311.578 4.622.89 6.934.967M18 23c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5-5 2.2386-5 5 2.2386 5 5 5Z"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M18 16v2l1.25 1.25"
      key="1"
    />,
  ],
  'Waitlist',
  24
);

export const WalletAltIcon = createSvgIcon(
  [
    <rect
      width="20"
      height="18"
      x="2"
      y="3"
      stroke="currentColor"
      strokeWidth="2"
      rx="2"
      key="0"
    />,
    <rect
      width="20"
      height="14"
      x="2"
      y="7"
      stroke="currentColor"
      strokeWidth="2"
      rx="2"
      key="1"
    />,
    <path
      fill="currentColor"
      d="m9.1707 11 .9428-.3332L9.8779 10h-.7072zm5.6586 0v-1h-.7072l-.2356.6668zM4 11v1h5.1707v-2H4zm-2 2h1c0-.5523.4477-1 1-1v-2c-1.6568 0-3 1.3431-3 3zm0 6h1v-6H1v6zm2 2v-1c-.5523 0-1-.4477-1-1H1c0 1.6569 1.3432 3 3 3zm16 0v-1H4v2h16zm2-2h-1c0 .5523-.4477 1-1 1v2c1.6569 0 3-1.3431 3-3zm0-6h-1v6h2v-6zm-2-2v1c.5523 0 1 .4477 1 1h2c0-1.6569-1.3431-3-3-3zm-5.1707 0v1H20v-2h-5.1707zm0 0-.9428-.3332C13.6114 11.4449 12.8693 12 12 12v2c1.7432 0 3.2235-1.1145 3.7721-2.6668zM12 13v-1c-.8693 0-1.6114-.5551-1.8865-1.3332L9.1707 11l-.9428.3332C8.7765 12.8855 10.2568 14 12 14z"
      key="2"
    />,
  ],
  'WalletAlt',
  24
);

export const WalletIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M21 12V6H3c-1.105 0-2-.895-2-2v15c0 1.657 1.343 3 3 3h17v-6"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M17 3V2H3c-1.105 0-2 .895-2 2s.895 2 2 2m20 9c0 .5523-.4477 1-1 1h-4c-1.105 0-2-.895-2-2s.895-2 2-2h4c.5523 0 1 .4477 1 1z"
      key="1"
    />,
  ],
  'Wallet',
  24
);

export const WheelchairIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M12 5c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2Z"
      key="0"
    />,
    <path
      fill="currentColor"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M21 22c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1Z"
      key="1"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="m7 14.5-1.562-2.734c-.25-.438-.135-.994.268-1.296l2.76-2.07c.346-.26.767-.4 1.2-.4h2.486c.489 0 .906.353.986.836l.721 4.329c.08.482.498.836.986.836h2.486a1 1 0 0 1 .923.615l.994 2.385"
      key="2"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M5.039 17.392C5.242 19.967 7.372 22 10 22c2.761 0 5-2.239 5-5s-2.239-5-5-5c-.129 0-.25.028-.376.038"
      key="3"
    />,
  ],
  'Wheelchair',
  24
);

export const WidgetSimpleIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeWidth="2"
      d="M2 20.4V3.6c0-.3314.2985-.6.6667-.6h18.6666c.3683 0 .6667.2686.6667.6v16.8c0 .3314-.2984.6-.6667.6H2.6667C2.2985 21 2 20.7314 2 20.4Z"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeWidth="2"
      d="M17 15.9579h-5.1158v-.5684a1.727 1.727 0 0 1 1.0442-1.5864l2.5951-1.1174A2.442 2.442 0 0 0 17 10.4424C17 9.0935 15.9065 8 14.5576 8h-.3997c-1.2557 0-2.2737 1.018-2.2737 2.2737m-3.0421 5.6842V8h-.5684L6 9.7053"
      key="1"
    />,
  ],
  'WidgetSimple',
  24
);

export const WidgetIcon = createSvgIcon(
  [
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M16 10H6m0-3h6M6 18l4.5-3 2.5 2 5-4"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeWidth="2"
      d="M2 20.4V3.6c0-.3314.2985-.6.6667-.6h18.6666c.3683 0 .6667.2686.6667.6v16.8c0 .3314-.2984.6-.6667.6H2.6667C2.2985 21 2 20.7314 2 20.4Z"
      key="1"
    />,
  ],
  'Widget',
  24
);

export const WorldPinIcon = createSvgIcon(
  [
    <g key="0">
      <path
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="m5.423 4.314 1.539 1.265 1.571 1.677-.387 2.615-2.475 1.253-1.307 1.115L5 13.324l1.248 1.337.674 2.36-1.874 1.572-.343 1.459m5.686 2.824-.166-1.059 1.955-2.112.967-2.655 3.096-1.175 3 .599 1.653 1.602"
      />
      <path
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M22.394 11a10.488 10.488 0 1 1-7.468-8.587"
      />
      <path
        fill="currentColor"
        d="M18 6c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1"
      />
      <path
        stroke="currentColor"
        strokeLinecap="square"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M22 5c0 2.469-4 6-4 6s-4-3.531-4-6a4 4 0 0 1 4-4 4 4 0 0 1 4 4Z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'WorldPin',
  24
);

export const WorldIcon = createSvgIcon(
  [
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      key="0"
    >
      <path d="M5.11 3.425 6.722 4.75l1.645 1.756-.404 2.74-2.594 1.312L4 11.726l.667 1.138 1.307 1.4.706 2.473-1.963 1.647-.359 1.5281M20.32 4.805l-1.477.838-3 .357-2.284-1.838-.62-1.813L12.127 1m6.88 11.903-.928 2.098-.954 2.151-1.763 1.641-2.339.15-1.394-1.69.468-2.17-.403-2.143 1.593-1.997 2.227-.782 2.358.564z" />
      <path d="M12 23c6.0751 0 11-4.9249 11-11S18.0751 1 12 1 1 5.9249 1 12s4.9249 11 11 11" />
    </g>,
    <defs key="1"></defs>,
  ],
  'World',
  24
);
